"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * ServiceNow AI Toolkit
 * ServiceNow AI Toolkit API
 *
 * The version of the OpenAPI document:
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolkitApi = exports.ToolkitApiFactory = exports.ToolkitApiFp = exports.ToolkitApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * ToolkitApi - axios parameter creator
 * @export
 */
const ToolkitApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get apps in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountAppGet: (accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (accountId, limit, offset, order, permission, q, human, recursive, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountAppGet', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/app`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create app in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {AppPost} [appPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountAppPost: (accountId_1, human_1, appPost_1, ...args_1) => __awaiter(this, [accountId_1, human_1, appPost_1, ...args_1], void 0, function* (accountId, human, appPost, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountAppPost', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/app`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(appPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get data in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountDataGet: (accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (accountId, limit, offset, order, permission, q, human, recursive, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountDataGet', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/data`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create data in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {DataPost} [dataPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountDataPost: (accountId_1, human_1, dataPost_1, ...args_1) => __awaiter(this, [accountId_1, human_1, dataPost_1, ...args_1], void 0, function* (accountId, human, dataPost, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountDataPost', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/data`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(dataPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get accounts in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountGet: (accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (accountId, limit, offset, order, permission, q, human, recursive, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountGet', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/account`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountGetById: (accountId_1, human_1, ...args_1) => __awaiter(this, [accountId_1, human_1, ...args_1], void 0, function* (accountId, human, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountGetById', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Check access to the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountHeadById: (accountId_1, human_1, ...args_1) => __awaiter(this, [accountId_1, human_1, ...args_1], void 0, function* (accountId, human, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountHeadById', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'HEAD' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get jobs in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobGet: (accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (accountId, limit, offset, order, permission, q, human, recursive, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountJobGet', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/job`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get job occupation statistics for an account
         * @param {string} accountId The ID or fullname of the account
         * @param {V1AccountJobOccupancyGetTypeParameter} [type] Get occupancy statistics by day, week, month, or year
         * @param {string} [from] date (YYYY-MM-DD)
         * @param {string} [to] date (YYYY-MM-DD)
         * @param {number} [noNull] When set to 1, the dates without data are omitted from the reply.
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobOccupancyGet: (accountId_1, type_1, from_1, to_1, noNull_1, limit_1, offset_1, order_1, ...args_1) => __awaiter(this, [accountId_1, type_1, from_1, to_1, noNull_1, limit_1, offset_1, order_1, ...args_1], void 0, function* (accountId, type, from, to, noNull, limit, offset, order, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountJobOccupancyGet', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/job_occupancy`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            if (noNull !== undefined) {
                localVarQueryParameter['no_null'] = noNull;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create job in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {JobSpec} [jobSpec]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobPost: (accountId_1, human_1, jobSpec_1, ...args_1) => __awaiter(this, [accountId_1, human_1, jobSpec_1, ...args_1], void 0, function* (accountId, human, jobSpec, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountJobPost', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/job`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(jobSpec, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get runs of jobs in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobRunGet: (accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (accountId, limit, offset, order, permission, q, human, recursive, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountJobRunGet', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/job_run`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create account in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {AccountPost} [accountPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountPost: (accountId_1, human_1, accountPost_1, ...args_1) => __awaiter(this, [accountId_1, human_1, accountPost_1, ...args_1], void 0, function* (accountId, human, accountPost, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountPost', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/account`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accountPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {AccountPost} [accountPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountPutById: (accountId_1, human_1, accountPost_1, ...args_1) => __awaiter(this, [accountId_1, human_1, accountPost_1, ...args_1], void 0, function* (accountId, human, accountPost, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountPutById', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accountPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all jobs in the account which are replica jobs
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountReplicaJobsGet: (accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (accountId, limit, offset, order, permission, q, human, recursive, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountReplicaJobsGet', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/replica_jobs`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get policies in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountRoleGet: (accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (accountId, limit, offset, order, permission, q, human, recursive, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountRoleGet', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/role`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create role in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {RolePost} [rolePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountRolePost: (accountId_1, human_1, rolePost_1, ...args_1) => __awaiter(this, [accountId_1, human_1, rolePost_1, ...args_1], void 0, function* (accountId, human, rolePost, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountRolePost', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/role`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rolePost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get services in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountServiceGet: (accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (accountId, limit, offset, order, permission, q, human, recursive, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountServiceGet', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/service`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create service in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {ServicePost} [servicePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountServicePost: (accountId_1, human_1, servicePost_1, ...args_1) => __awaiter(this, [accountId_1, human_1, servicePost_1, ...args_1], void 0, function* (accountId, human, servicePost, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountServicePost', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/service`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(servicePost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List allowed operations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AllowedOperationGet: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/v1/allowed_operation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Check permission (action & resource) for a given user or role (defaults to yourself)
         * @param {Allowed} [allowed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AllowedPost: (allowed_1, ...args_1) => __awaiter(this, [allowed_1, ...args_1], void 0, function* (allowed, options = {}) {
            const localVarPath = `/v1/allowed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(allowed, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete app
         * @param {string} appId The ID or fullname of the app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AppDeleteById: (appId_1, ...args_1) => __awaiter(this, [appId_1, ...args_1], void 0, function* (appId, options = {}) {
            // verify required parameter 'appId' is not null or undefined
            (0, common_1.assertParamExists)('v1AppDeleteById', 'appId', appId);
            const localVarPath = `/v1/app/{app_id}`
                .replace(`{${"app_id"}}`, encodeURIComponent(String(appId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get app
         * @param {string} appId The ID or fullname of the app
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AppGetById: (appId_1, human_1, ...args_1) => __awaiter(this, [appId_1, human_1, ...args_1], void 0, function* (appId, human, options = {}) {
            // verify required parameter 'appId' is not null or undefined
            (0, common_1.assertParamExists)('v1AppGetById', 'appId', appId);
            const localVarPath = `/v1/app/{app_id}`
                .replace(`{${"app_id"}}`, encodeURIComponent(String(appId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Check access to the app
         * @param {string} appId The ID or fullname of the app
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AppHeadById: (appId_1, human_1, ...args_1) => __awaiter(this, [appId_1, human_1, ...args_1], void 0, function* (appId, human, options = {}) {
            // verify required parameter 'appId' is not null or undefined
            (0, common_1.assertParamExists)('v1AppHeadById', 'appId', appId);
            const localVarPath = `/v1/app/{app_id}`
                .replace(`{${"app_id"}}`, encodeURIComponent(String(appId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'HEAD' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update app
         * @param {string} appId The ID or fullname of the app
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {AppPost} [appPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AppPutById: (appId_1, human_1, appPost_1, ...args_1) => __awaiter(this, [appId_1, human_1, appPost_1, ...args_1], void 0, function* (appId, human, appPost, options = {}) {
            // verify required parameter 'appId' is not null or undefined
            (0, common_1.assertParamExists)('v1AppPutById', 'appId', appId);
            const localVarPath = `/v1/app/{app_id}`
                .replace(`{${"app_id"}}`, encodeURIComponent(String(appId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(appPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get accounts in the cluster
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterAccountGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, options = {}) {
            const localVarPath = `/v1/cluster/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get apps in the cluster
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterAppGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, options = {}) {
            const localVarPath = `/v1/cluster/app`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get data in the cluster
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterDataGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, options = {}) {
            const localVarPath = `/v1/cluster/data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get jobs in the cluster
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterJobGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, options = {}) {
            const localVarPath = `/v1/cluster/job`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get job occupation statistics in the cluster
         * @param {V1AccountJobOccupancyGetTypeParameter} [type] Get occupancy statistics by day, week, month, or year
         * @param {string} [from] date (YYYY-MM-DD)
         * @param {string} [to] date (YYYY-MM-DD)
         * @param {number} [noNull] When set to 1, the dates without data are omitted from the reply.
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterJobOccupancyGet: (type_1, from_1, to_1, noNull_1, limit_1, offset_1, order_1, ...args_1) => __awaiter(this, [type_1, from_1, to_1, noNull_1, limit_1, offset_1, order_1, ...args_1], void 0, function* (type, from, to, noNull, limit, offset, order, options = {}) {
            const localVarPath = `/v1/cluster/job_occupancy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            if (noNull !== undefined) {
                localVarQueryParameter['no_null'] = noNull;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get runs of jobs in the cluster
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterJobRunGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, options = {}) {
            const localVarPath = `/v1/cluster/job_run`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get private registries in the cluster
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterPrivateRegistryGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, options = {}) {
            const localVarPath = `/v1/cluster/privateregistry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get roles in the cluster
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterRoleGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, options = {}) {
            const localVarPath = `/v1/cluster/role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get services in the cluster
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterServiceGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, options = {}) {
            const localVarPath = `/v1/cluster/service`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get teams in the cluster
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterTeamGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, options = {}) {
            const localVarPath = `/v1/cluster/team`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get users in the cluster
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterUserGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, options = {}) {
            const localVarPath = `/v1/cluster/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Commit a data and create a version and optionaly a tag
         * @param {string} dataId The ID or fullname associated to the data
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {string} [tag] Data tag to use
         * @param {string} [version] Data version to use
         * @param {Data} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataCommitPost: (dataId_1, human_1, tag_1, version_1, data_1, ...args_1) => __awaiter(this, [dataId_1, human_1, tag_1, version_1, data_1, ...args_1], void 0, function* (dataId, human, tag, version, data, options = {}) {
            // verify required parameter 'dataId' is not null or undefined
            (0, common_1.assertParamExists)('v1DataCommitPost', 'dataId', dataId);
            const localVarPath = `/v1/data/{data_id}/commit`
                .replace(`{${"data_id"}}`, encodeURIComponent(String(dataId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (tag !== undefined) {
                localVarQueryParameter['tag'] = tag;
            }
            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Download a data
         * @param {string} dataId The ID or fullname associated to the data
         * @param {string} [version] Data version to use
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataDownloadGet: (dataId_1, version_1, ...args_1) => __awaiter(this, [dataId_1, version_1, ...args_1], void 0, function* (dataId, version, options = {}) {
            // verify required parameter 'dataId' is not null or undefined
            (0, common_1.assertParamExists)('v1DataDownloadGet', 'dataId', dataId);
            const localVarPath = `/v1/data/{data_id}/download`
                .replace(`{${"data_id"}}`, encodeURIComponent(String(dataId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the data identified by id
         * @param {string} dataId The ID or fullname associated to the data
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataGetById: (dataId_1, human_1, ...args_1) => __awaiter(this, [dataId_1, human_1, ...args_1], void 0, function* (dataId, human, options = {}) {
            // verify required parameter 'dataId' is not null or undefined
            (0, common_1.assertParamExists)('v1DataGetById', 'dataId', dataId);
            const localVarPath = `/v1/data/{data_id}`
                .replace(`{${"data_id"}}`, encodeURIComponent(String(dataId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Check access to the data
         * @param {string} dataId The ID or fullname of the data
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataHeadById: (dataId_1, human_1, ...args_1) => __awaiter(this, [dataId_1, human_1, ...args_1], void 0, function* (dataId, human, options = {}) {
            // verify required parameter 'dataId' is not null or undefined
            (0, common_1.assertParamExists)('v1DataHeadById', 'dataId', dataId);
            const localVarPath = `/v1/data/{data_id}`
                .replace(`{${"data_id"}}`, encodeURIComponent(String(dataId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'HEAD' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Check if a data is using dataV2
         * @param {string} dataId The ID or fullname associated to the data
         * @param {string} [version] Data version to use
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataIsV2Get: (dataId_1, version_1, ...args_1) => __awaiter(this, [dataId_1, version_1, ...args_1], void 0, function* (dataId, version, options = {}) {
            // verify required parameter 'dataId' is not null or undefined
            (0, common_1.assertParamExists)('v1DataIsV2Get', 'dataId', dataId);
            const localVarPath = `/v1/data/{data_id}/isv2`
                .replace(`{${"data_id"}}`, encodeURIComponent(String(dataId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Check if a data is using dataV2. Return \'true\' or \'false\'
         * @param {string} dataId The ID or fullname associated to the data
         * @param {string} [version] Data version to use
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataListGet: (dataId_1, version_1, ...args_1) => __awaiter(this, [dataId_1, version_1, ...args_1], void 0, function* (dataId, version, options = {}) {
            // verify required parameter 'dataId' is not null or undefined
            (0, common_1.assertParamExists)('v1DataListGet', 'dataId', dataId);
            const localVarPath = `/v1/data/{data_id}/list`
                .replace(`{${"data_id"}}`, encodeURIComponent(String(dataId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Pull data
         * @param {string} dataId The ID or fullname associated to the data
         * @param {string} [version] Data version to use
         * @param {string} [mapping] Path of the remote path and local path. Can specify immutable/mutable version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataPullGet: (dataId_1, version_1, mapping_1, ...args_1) => __awaiter(this, [dataId_1, version_1, mapping_1, ...args_1], void 0, function* (dataId, version, mapping, options = {}) {
            // verify required parameter 'dataId' is not null or undefined
            (0, common_1.assertParamExists)('v1DataPullGet', 'dataId', dataId);
            const localVarPath = `/v1/data/{data_id}/pull`
                .replace(`{${"data_id"}}`, encodeURIComponent(String(dataId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }
            if (mapping !== undefined) {
                localVarQueryParameter['mapping'] = mapping;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Push data
         * @param {string} chunk Chunk ID pushed
         * @param {string} dataId The ID or fullname associated to the data
         * @param {string} [version] Data version to use
         * @param {string} [state] State to resume push
         * @param {File} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataPushPost: (chunk_1, dataId_1, version_1, state_1, body_1, ...args_1) => __awaiter(this, [chunk_1, dataId_1, version_1, state_1, body_1, ...args_1], void 0, function* (chunk, dataId, version, state, body, options = {}) {
            // verify required parameter 'chunk' is not null or undefined
            (0, common_1.assertParamExists)('v1DataPushPost', 'chunk', chunk);
            // verify required parameter 'dataId' is not null or undefined
            (0, common_1.assertParamExists)('v1DataPushPost', 'dataId', dataId);
            const localVarPath = `/v1/data/{data_id}/push`
                .replace(`{${"data_id"}}`, encodeURIComponent(String(dataId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }
            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }
            if (chunk !== undefined) {
                localVarQueryParameter['chunk'] = chunk;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update data
         * @param {string} dataId The ID or fullname of the data
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {DataPost} [dataPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataPutById: (dataId_1, human_1, dataPost_1, ...args_1) => __awaiter(this, [dataId_1, human_1, dataPost_1, ...args_1], void 0, function* (dataId, human, dataPost, options = {}) {
            // verify required parameter 'dataId' is not null or undefined
            (0, common_1.assertParamExists)('v1DataPutById', 'dataId', dataId);
            const localVarPath = `/v1/data/{data_id}`
                .replace(`{${"data_id"}}`, encodeURIComponent(String(dataId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(dataPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Return data tree
         * @param {string} dataId The ID or fullname associated to the data
         * @param {string} [version] Data version to use
         * @param {string} [kind] Kind to display data tree: ls or tree
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataTreeGet: (dataId_1, version_1, kind_1, ...args_1) => __awaiter(this, [dataId_1, version_1, kind_1, ...args_1], void 0, function* (dataId, version, kind, options = {}) {
            // verify required parameter 'dataId' is not null or undefined
            (0, common_1.assertParamExists)('v1DataTreeGet', 'dataId', dataId);
            const localVarPath = `/v1/data/{data_id}/tree`
                .replace(`{${"data_id"}}`, encodeURIComponent(String(dataId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }
            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update data version
         * @param {string} dataId The ID or fullname associated to the data
         * @param {string} version Data version to use
         * @param {Data} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataUpdatePost: (dataId_1, version_1, data_1, ...args_1) => __awaiter(this, [dataId_1, version_1, data_1, ...args_1], void 0, function* (dataId, version, data, options = {}) {
            // verify required parameter 'dataId' is not null or undefined
            (0, common_1.assertParamExists)('v1DataUpdatePost', 'dataId', dataId);
            // verify required parameter 'version' is not null or undefined
            (0, common_1.assertParamExists)('v1DataUpdatePost', 'version', version);
            const localVarPath = `/v1/data/{data_id}/update/{version}`
                .replace(`{${"data_id"}}`, encodeURIComponent(String(dataId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Upload data
         * @param {string} chunk Chunk ID pushed
         * @param {string} dataId The ID or fullname associated to the data
         * @param {string} [version] Data version to use
         * @param {string} [state] State to resume push
         * @param {File} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataUploadPost: (chunk_1, dataId_1, version_1, state_1, body_1, ...args_1) => __awaiter(this, [chunk_1, dataId_1, version_1, state_1, body_1, ...args_1], void 0, function* (chunk, dataId, version, state, body, options = {}) {
            // verify required parameter 'chunk' is not null or undefined
            (0, common_1.assertParamExists)('v1DataUploadPost', 'chunk', chunk);
            // verify required parameter 'dataId' is not null or undefined
            (0, common_1.assertParamExists)('v1DataUploadPost', 'dataId', dataId);
            const localVarPath = `/v1/data/{data_id}/upload`
                .replace(`{${"data_id"}}`, encodeURIComponent(String(dataId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }
            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }
            if (chunk !== undefined) {
                localVarQueryParameter['chunk'] = chunk;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update bid of the job
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {JobRebid} [jobRebid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobBidPut: (jobId_1, human_1, jobRebid_1, ...args_1) => __awaiter(this, [jobId_1, human_1, jobRebid_1, ...args_1], void 0, function* (jobId, human, jobRebid, options = {}) {
            // verify required parameter 'jobId' is not null or undefined
            (0, common_1.assertParamExists)('v1JobBidPut', 'jobId', jobId);
            const localVarPath = `/v1/job/{job_id}/bid`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(jobRebid, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get process agent children of the job
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobChildrenGet: (jobId_1, human_1, ...args_1) => __awaiter(this, [jobId_1, human_1, ...args_1], void 0, function* (jobId, human, options = {}) {
            // verify required parameter 'jobId' is not null or undefined
            (0, common_1.assertParamExists)('v1JobChildrenGet', 'jobId', jobId);
            const localVarPath = `/v1/job/{job_id}/children`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Check if job is consented
         * @param {string} jobId The ID or fullname associated to the job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobConsentHead: (jobId_1, ...args_1) => __awaiter(this, [jobId_1, ...args_1], void 0, function* (jobId, options = {}) {
            // verify required parameter 'jobId' is not null or undefined
            (0, common_1.assertParamExists)('v1JobConsentHead', 'jobId', jobId);
            const localVarPath = `/v1/job/{job_id}/consent`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'HEAD' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Consent to job scopes
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobConsentPost: (jobId_1, human_1, ...args_1) => __awaiter(this, [jobId_1, human_1, ...args_1], void 0, function* (jobId, human, options = {}) {
            // verify required parameter 'jobId' is not null or undefined
            (0, common_1.assertParamExists)('v1JobConsentPost', 'jobId', jobId);
            const localVarPath = `/v1/job/{job_id}/consent`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Cancel (a.k.a. kill) a queued, queuing or running job
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobDeleteById: (jobId_1, human_1, ...args_1) => __awaiter(this, [jobId_1, human_1, ...args_1], void 0, function* (jobId, human, options = {}) {
            // verify required parameter 'jobId' is not null or undefined
            (0, common_1.assertParamExists)('v1JobDeleteById', 'jobId', jobId);
            const localVarPath = `/v1/job/{job_id}`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Execute a command in a running job
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobExecGet: (jobId_1, human_1, ...args_1) => __awaiter(this, [jobId_1, human_1, ...args_1], void 0, function* (jobId, human, options = {}) {
            // verify required parameter 'jobId' is not null or undefined
            (0, common_1.assertParamExists)('v1JobExecGet', 'jobId', jobId);
            const localVarPath = `/v1/job/{job_id}/exec`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get job information
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobGetById: (jobId_1, human_1, ...args_1) => __awaiter(this, [jobId_1, human_1, ...args_1], void 0, function* (jobId, human, options = {}) {
            // verify required parameter 'jobId' is not null or undefined
            (0, common_1.assertParamExists)('v1JobGetById', 'jobId', jobId);
            const localVarPath = `/v1/job/{job_id}`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Check access to the job
         * @param {string} jobId The ID or fullname of the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobHeadById: (jobId_1, human_1, ...args_1) => __awaiter(this, [jobId_1, human_1, ...args_1], void 0, function* (jobId, human, options = {}) {
            // verify required parameter 'jobId' is not null or undefined
            (0, common_1.assertParamExists)('v1JobHeadById', 'jobId', jobId);
            const localVarPath = `/v1/job/{job_id}`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'HEAD' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Return logs of a job
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [follow] WebSocket will continue to receive new logs if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobLogsGet: (jobId_1, follow_1, ...args_1) => __awaiter(this, [jobId_1, follow_1, ...args_1], void 0, function* (jobId, follow, options = {}) {
            // verify required parameter 'jobId' is not null or undefined
            (0, common_1.assertParamExists)('v1JobLogsGet', 'jobId', jobId);
            const localVarPath = `/v1/job/{job_id}/logs`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (follow !== undefined) {
                localVarQueryParameter['follow'] = follow;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Return logs of a job for a given run
         * @param {string} jobId The ID or fullname associated to the job
         * @param {string} runId ID of the run
         * @param {number} [follow] WebSocket will continue to receive new logs if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobLogsRunGet: (jobId_1, runId_1, follow_1, ...args_1) => __awaiter(this, [jobId_1, runId_1, follow_1, ...args_1], void 0, function* (jobId, runId, follow, options = {}) {
            // verify required parameter 'jobId' is not null or undefined
            (0, common_1.assertParamExists)('v1JobLogsRunGet', 'jobId', jobId);
            // verify required parameter 'runId' is not null or undefined
            (0, common_1.assertParamExists)('v1JobLogsRunGet', 'runId', runId);
            const localVarPath = `/v1/job/{job_id}/logs/{run_id}`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)))
                .replace(`{${"run_id"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (follow !== undefined) {
                localVarQueryParameter['follow'] = follow;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update job info like name, owner, etc
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {Job} [job]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobPutById: (jobId_1, human_1, job_1, ...args_1) => __awaiter(this, [jobId_1, human_1, job_1, ...args_1], void 0, function* (jobId, human, job, options = {}) {
            // verify required parameter 'jobId' is not null or undefined
            (0, common_1.assertParamExists)('v1JobPutById', 'jobId', jobId);
            const localVarPath = `/v1/job/{job_id}`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(job, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Retry an interrupted, failed or cancelled job
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobRetryPut: (jobId_1, human_1, ...args_1) => __awaiter(this, [jobId_1, human_1, ...args_1], void 0, function* (jobId, human, options = {}) {
            // verify required parameter 'jobId' is not null or undefined
            (0, common_1.assertParamExists)('v1JobRetryPut', 'jobId', jobId);
            const localVarPath = `/v1/job/{job_id}/retry`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Check permission (action & resource) for your user or role
         * @param {string} action Expression (supporting wildcards) denoting the action(s) performed on the resource(s)
         * @param {string} resource URN-like expression (supporting wildcards) for matching resource(s)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeAllowedGet: (action_1, resource_1, ...args_1) => __awaiter(this, [action_1, resource_1, ...args_1], void 0, function* (action, resource, options = {}) {
            // verify required parameter 'action' is not null or undefined
            (0, common_1.assertParamExists)('v1MeAllowedGet', 'action', action);
            // verify required parameter 'resource' is not null or undefined
            (0, common_1.assertParamExists)('v1MeAllowedGet', 'resource', resource);
            const localVarPath = `/v1/me/allowed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }
            if (resource !== undefined) {
                localVarQueryParameter['resource'] = resource;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get apps for your user
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeAppGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, options = {}) {
            const localVarPath = `/v1/me/app`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get your user/role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeGet: (human_1, ...args_1) => __awaiter(this, [human_1, ...args_1], void 0, function* (human, options = {}) {
            const localVarPath = `/v1/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get jobs created by your user/role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeJobGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, options = {}) {
            const localVarPath = `/v1/me/job`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get job occupation statistics for your user/role
         * @param {V1AccountJobOccupancyGetTypeParameter} [type] Get occupancy statistics by day, week, month, or year
         * @param {string} [from] date (YYYY-MM-DD)
         * @param {string} [to] date (YYYY-MM-DD)
         * @param {number} [noNull] When set to 1, the dates without data are omitted from the reply.
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeJobOccupancyGet: (type_1, from_1, to_1, noNull_1, limit_1, offset_1, order_1, ...args_1) => __awaiter(this, [type_1, from_1, to_1, noNull_1, limit_1, offset_1, order_1, ...args_1], void 0, function* (type, from, to, noNull, limit, offset, order, options = {}) {
            const localVarPath = `/v1/me/job_occupancy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            if (noNull !== undefined) {
                localVarQueryParameter['no_null'] = noNull;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get runs of jobs created by your user/role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeJobRunGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, options = {}) {
            const localVarPath = `/v1/me/job_run`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete a policy in your user/role
         * @param {string} policyId The ID or fullname of the policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MePolicyDelete: (policyId_1, ...args_1) => __awaiter(this, [policyId_1, ...args_1], void 0, function* (policyId, options = {}) {
            // verify required parameter 'policyId' is not null or undefined
            (0, common_1.assertParamExists)('v1MePolicyDelete', 'policyId', policyId);
            const localVarPath = `/v1/me/policy/{policy_id}`
                .replace(`{${"policy_id"}}`, encodeURIComponent(String(policyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get policies in your user/role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MePolicyGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, options = {}) {
            const localVarPath = `/v1/me/policy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Post a policy in your user/role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {PolicyPost} [policyPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MePolicyPost: (human_1, policyPost_1, ...args_1) => __awaiter(this, [human_1, policyPost_1, ...args_1], void 0, function* (human, policyPost, options = {}) {
            const localVarPath = `/v1/me/policy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(policyPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update your user/role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {UserOrRolePost} [userOrRolePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MePut: (human_1, userOrRolePost_1, ...args_1) => __awaiter(this, [human_1, userOrRolePost_1, ...args_1], void 0, function* (human, userOrRolePost, options = {}) {
            const localVarPath = `/v1/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userOrRolePost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get terms of the organization of your user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeTermsGet: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/v1/me/terms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Set terms as readed for your user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeTermsPut: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/v1/me/terms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get accounts in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationAccountGet: (organizationId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [organizationId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (organizationId, limit, offset, order, permission, q, human, recursive, options = {}) {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('v1OrganizationAccountGet', 'organizationId', organizationId);
            const localVarPath = `/v1/organization/{organization_id}/account`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create account in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {AccountPost} [accountPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationAccountPost: (organizationId_1, human_1, accountPost_1, ...args_1) => __awaiter(this, [organizationId_1, human_1, accountPost_1, ...args_1], void 0, function* (organizationId, human, accountPost, options = {}) {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('v1OrganizationAccountPost', 'organizationId', organizationId);
            const localVarPath = `/v1/organization/{organization_id}/account`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accountPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get apps in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationAppGet: (organizationId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [organizationId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (organizationId, limit, offset, order, permission, q, human, recursive, options = {}) {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('v1OrganizationAppGet', 'organizationId', organizationId);
            const localVarPath = `/v1/organization/{organization_id}/app`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create app in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {AppPost} [appPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationAppPost: (organizationId_1, human_1, appPost_1, ...args_1) => __awaiter(this, [organizationId_1, human_1, appPost_1, ...args_1], void 0, function* (organizationId, human, appPost, options = {}) {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('v1OrganizationAppPost', 'organizationId', organizationId);
            const localVarPath = `/v1/organization/{organization_id}/app`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(appPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get data in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationDataGet: (organizationId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [organizationId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (organizationId, limit, offset, order, permission, q, human, options = {}) {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('v1OrganizationDataGet', 'organizationId', organizationId);
            const localVarPath = `/v1/organization/{organization_id}/data`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get organizations
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, recursive, options = {}) {
            const localVarPath = `/v1/organization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the organization identified by id
         * @param {string} organizationId The ID or fullname associated to the organization
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationGetById: (organizationId_1, human_1, ...args_1) => __awaiter(this, [organizationId_1, human_1, ...args_1], void 0, function* (organizationId, human, options = {}) {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('v1OrganizationGetById', 'organizationId', organizationId);
            const localVarPath = `/v1/organization/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Check access to the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationHeadById: (organizationId_1, human_1, ...args_1) => __awaiter(this, [organizationId_1, human_1, ...args_1], void 0, function* (organizationId, human, options = {}) {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('v1OrganizationHeadById', 'organizationId', organizationId);
            const localVarPath = `/v1/organization/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'HEAD' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get jobs in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationJobGet: (organizationId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [organizationId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (organizationId, limit, offset, order, permission, q, human, options = {}) {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('v1OrganizationJobGet', 'organizationId', organizationId);
            const localVarPath = `/v1/organization/{organization_id}/job`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get job occupation statistics for an organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {V1AccountJobOccupancyGetTypeParameter} [type] Get occupancy statistics by day, week, month, or year
         * @param {string} [from] date (YYYY-MM-DD)
         * @param {string} [to] date (YYYY-MM-DD)
         * @param {number} [noNull] When set to 1, the dates without data are omitted from the reply.
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationJobOccupancyGet: (organizationId_1, type_1, from_1, to_1, noNull_1, limit_1, offset_1, order_1, ...args_1) => __awaiter(this, [organizationId_1, type_1, from_1, to_1, noNull_1, limit_1, offset_1, order_1, ...args_1], void 0, function* (organizationId, type, from, to, noNull, limit, offset, order, options = {}) {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('v1OrganizationJobOccupancyGet', 'organizationId', organizationId);
            const localVarPath = `/v1/organization/{organization_id}/job_occupancy`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            if (noNull !== undefined) {
                localVarQueryParameter['no_null'] = noNull;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get runs of jobs in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationJobRunGet: (organizationId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [organizationId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (organizationId, limit, offset, order, permission, q, human, options = {}) {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('v1OrganizationJobRunGet', 'organizationId', organizationId);
            const localVarPath = `/v1/organization/{organization_id}/job_run`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create organization
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {OrganizationPost} [organizationPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationPost: (human_1, organizationPost_1, ...args_1) => __awaiter(this, [human_1, organizationPost_1, ...args_1], void 0, function* (human, organizationPost, options = {}) {
            const localVarPath = `/v1/organization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(organizationPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {OrganizationPost} [organizationPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationPutById: (organizationId_1, human_1, organizationPost_1, ...args_1) => __awaiter(this, [organizationId_1, human_1, organizationPost_1, ...args_1], void 0, function* (organizationId, human, organizationPost, options = {}) {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('v1OrganizationPutById', 'organizationId', organizationId);
            const localVarPath = `/v1/organization/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(organizationPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all jobs in the organization which are replica jobs
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationReplicaJobsGet: (organizationId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [organizationId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (organizationId, limit, offset, order, permission, q, human, options = {}) {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('v1OrganizationReplicaJobsGet', 'organizationId', organizationId);
            const localVarPath = `/v1/organization/{organization_id}/replica_jobs`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get roles in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationRoleGet: (organizationId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [organizationId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (organizationId, limit, offset, order, permission, q, human, recursive, options = {}) {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('v1OrganizationRoleGet', 'organizationId', organizationId);
            const localVarPath = `/v1/organization/{organization_id}/role`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create role in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {RolePost} [rolePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationRolePost: (organizationId_1, human_1, rolePost_1, ...args_1) => __awaiter(this, [organizationId_1, human_1, rolePost_1, ...args_1], void 0, function* (organizationId, human, rolePost, options = {}) {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('v1OrganizationRolePost', 'organizationId', organizationId);
            const localVarPath = `/v1/organization/{organization_id}/role`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rolePost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get services in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationServiceGet: (organizationId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [organizationId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (organizationId, limit, offset, order, permission, q, human, options = {}) {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('v1OrganizationServiceGet', 'organizationId', organizationId);
            const localVarPath = `/v1/organization/{organization_id}/service`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get teams in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationTeamGet: (organizationId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [organizationId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (organizationId, limit, offset, order, permission, q, human, options = {}) {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('v1OrganizationTeamGet', 'organizationId', organizationId);
            const localVarPath = `/v1/organization/{organization_id}/team`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create team in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {TeamPost} [teamPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationTeamPost: (organizationId_1, human_1, teamPost_1, ...args_1) => __awaiter(this, [organizationId_1, human_1, teamPost_1, ...args_1], void 0, function* (organizationId, human, teamPost, options = {}) {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('v1OrganizationTeamPost', 'organizationId', organizationId);
            const localVarPath = `/v1/organization/{organization_id}/team`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(teamPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get users in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationUserGet: (organizationId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [organizationId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (organizationId, limit, offset, order, permission, q, human, options = {}) {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('v1OrganizationUserGet', 'organizationId', organizationId);
            const localVarPath = `/v1/organization/{organization_id}/user`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create user in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {UserPost} [userPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationUserPost: (organizationId_1, human_1, userPost_1, ...args_1) => __awaiter(this, [organizationId_1, human_1, userPost_1, ...args_1], void 0, function* (organizationId, human, userPost, options = {}) {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('v1OrganizationUserPost', 'organizationId', organizationId);
            const localVarPath = `/v1/organization/{organization_id}/user`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the private registry identified by id
         * @param {string} privateregistryId The ID or fullname associated to the private registry
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PrivateRegistryGetById: (privateregistryId_1, human_1, ...args_1) => __awaiter(this, [privateregistryId_1, human_1, ...args_1], void 0, function* (privateregistryId, human, options = {}) {
            // verify required parameter 'privateregistryId' is not null or undefined
            (0, common_1.assertParamExists)('v1PrivateRegistryGetById', 'privateregistryId', privateregistryId);
            const localVarPath = `/v1/privateregistry/{privateregistry_id}`
                .replace(`{${"privateregistry_id"}}`, encodeURIComponent(String(privateregistryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Check access to the privateregistry
         * @param {string} privateregistryId The ID or fullname of the private registry
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PrivateRegistryHeadById: (privateregistryId_1, human_1, ...args_1) => __awaiter(this, [privateregistryId_1, human_1, ...args_1], void 0, function* (privateregistryId, human, options = {}) {
            // verify required parameter 'privateregistryId' is not null or undefined
            (0, common_1.assertParamExists)('v1PrivateRegistryHeadById', 'privateregistryId', privateregistryId);
            const localVarPath = `/v1/privateregistry/{privateregistry_id}`
                .replace(`{${"privateregistry_id"}}`, encodeURIComponent(String(privateregistryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'HEAD' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update private registry
         * @param {string} privateregistryId The ID or fullname of the private registry
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {PrivateregistryPost} [privateregistryPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PrivateRegistryPutById: (privateregistryId_1, human_1, privateregistryPost_1, ...args_1) => __awaiter(this, [privateregistryId_1, human_1, privateregistryPost_1, ...args_1], void 0, function* (privateregistryId, human, privateregistryPost, options = {}) {
            // verify required parameter 'privateregistryId' is not null or undefined
            (0, common_1.assertParamExists)('v1PrivateRegistryPutById', 'privateregistryId', privateregistryId);
            const localVarPath = `/v1/privateregistry/{privateregistry_id}`
                .replace(`{${"privateregistry_id"}}`, encodeURIComponent(String(privateregistryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(privateregistryPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Cancel ReplicaJobs via replicaGroupId
         * @param {string} replicaGroupId The replicaGroupId of the ReplicaJobs
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ReplicaJobsDeleteByReplicaGroupId: (replicaGroupId_1, human_1, ...args_1) => __awaiter(this, [replicaGroupId_1, human_1, ...args_1], void 0, function* (replicaGroupId, human, options = {}) {
            // verify required parameter 'replicaGroupId' is not null or undefined
            (0, common_1.assertParamExists)('v1ReplicaJobsDeleteByReplicaGroupId', 'replicaGroupId', replicaGroupId);
            const localVarPath = `/v1/replica_jobs/{replica_group_id}`
                .replace(`{${"replica_group_id"}}`, encodeURIComponent(String(replicaGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get ReplicaJobs via replicaGroupId
         * @param {string} replicaGroupId The replicaGroupId of the ReplicaJobs
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ReplicaJobsGetByReplicaGroupId: (replicaGroupId_1, human_1, ...args_1) => __awaiter(this, [replicaGroupId_1, human_1, ...args_1], void 0, function* (replicaGroupId, human, options = {}) {
            // verify required parameter 'replicaGroupId' is not null or undefined
            (0, common_1.assertParamExists)('v1ReplicaJobsGetByReplicaGroupId', 'replicaGroupId', replicaGroupId);
            const localVarPath = `/v1/replica_jobs/{replica_group_id}`
                .replace(`{${"replica_group_id"}}`, encodeURIComponent(String(replicaGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Check access to the ReplicaJobs via replicaGroupId
         * @param {string} replicaGroupId The replicaGroupId of the ReplicaJobs
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ReplicaJobsHeadByReplicaGroupId: (replicaGroupId_1, human_1, ...args_1) => __awaiter(this, [replicaGroupId_1, human_1, ...args_1], void 0, function* (replicaGroupId, human, options = {}) {
            // verify required parameter 'replicaGroupId' is not null or undefined
            (0, common_1.assertParamExists)('v1ReplicaJobsHeadByReplicaGroupId', 'replicaGroupId', replicaGroupId);
            const localVarPath = `/v1/replica_jobs/{replica_group_id}`
                .replace(`{${"replica_group_id"}}`, encodeURIComponent(String(replicaGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'HEAD' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Check permission (action & resource) for a given user or role
         * @param {string} resourceId The ID or fullname of the resource
         * @param {string} action Expression (supporting wildcards) denoting the action(s) performed on the resource(s)
         * @param {string} resource URN-like expression (supporting wildcards) for matching resource(s)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ResourceAllowedGet: (resourceId_1, action_1, resource_1, ...args_1) => __awaiter(this, [resourceId_1, action_1, resource_1, ...args_1], void 0, function* (resourceId, action, resource, options = {}) {
            // verify required parameter 'resourceId' is not null or undefined
            (0, common_1.assertParamExists)('v1ResourceAllowedGet', 'resourceId', resourceId);
            // verify required parameter 'action' is not null or undefined
            (0, common_1.assertParamExists)('v1ResourceAllowedGet', 'action', action);
            // verify required parameter 'resource' is not null or undefined
            (0, common_1.assertParamExists)('v1ResourceAllowedGet', 'resource', resource);
            const localVarPath = `/v1/resource/{resource_id}/allowed`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }
            if (resource !== undefined) {
                localVarQueryParameter['resource'] = resource;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get resource
         * @param {string} resourceId The ID or fullname of the resource
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ResourceGetById: (resourceId_1, human_1, ...args_1) => __awaiter(this, [resourceId_1, human_1, ...args_1], void 0, function* (resourceId, human, options = {}) {
            // verify required parameter 'resourceId' is not null or undefined
            (0, common_1.assertParamExists)('v1ResourceGetById', 'resourceId', resourceId);
            const localVarPath = `/v1/resource/{resource_id}`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Check access to the resource
         * @param {string} resourceId The ID or fullname of the resource
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ResourceHeadById: (resourceId_1, human_1, ...args_1) => __awaiter(this, [resourceId_1, human_1, ...args_1], void 0, function* (resourceId, human, options = {}) {
            // verify required parameter 'resourceId' is not null or undefined
            (0, common_1.assertParamExists)('v1ResourceHeadById', 'resourceId', resourceId);
            const localVarPath = `/v1/resource/{resource_id}`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'HEAD' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Resolve a resource id
         * @param {string} resourceId The ID or fullname of the resource
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ResourceIdGet: (resourceId_1, human_1, ...args_1) => __awaiter(this, [resourceId_1, human_1, ...args_1], void 0, function* (resourceId, human, options = {}) {
            // verify required parameter 'resourceId' is not null or undefined
            (0, common_1.assertParamExists)('v1ResourceIdGet', 'resourceId', resourceId);
            const localVarPath = `/v1/resource/{resource_id}/id`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get roles in the resource
         * @param {string} resourceId The ID or fullname of the resource
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ResourceRoleGet: (resourceId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [resourceId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (resourceId, limit, offset, order, permission, q, human, recursive, options = {}) {
            // verify required parameter 'resourceId' is not null or undefined
            (0, common_1.assertParamExists)('v1ResourceRoleGet', 'resourceId', resourceId);
            const localVarPath = `/v1/resource/{resource_id}/role`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create role in the resource
         * @param {string} resourceId The ID or fullname of the resource
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {RolePost} [rolePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ResourceRolePost: (resourceId_1, human_1, rolePost_1, ...args_1) => __awaiter(this, [resourceId_1, human_1, rolePost_1, ...args_1], void 0, function* (resourceId, human, rolePost, options = {}) {
            // verify required parameter 'resourceId' is not null or undefined
            (0, common_1.assertParamExists)('v1ResourceRolePost', 'resourceId', resourceId);
            const localVarPath = `/v1/resource/{resource_id}/role`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rolePost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Check permission (action & resource) for a given role
         * @param {string} action Expression (supporting wildcards) denoting the action(s) performed on the resource(s)
         * @param {string} resource URN-like expression (supporting wildcards) for matching resource(s)
         * @param {string} roleId The ID or fullname of the role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleAllowedGet: (action_1, resource_1, roleId_1, ...args_1) => __awaiter(this, [action_1, resource_1, roleId_1, ...args_1], void 0, function* (action, resource, roleId, options = {}) {
            // verify required parameter 'action' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleAllowedGet', 'action', action);
            // verify required parameter 'resource' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleAllowedGet', 'resource', resource);
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleAllowedGet', 'roleId', roleId);
            const localVarPath = `/v1/role/{role_id}/allowed`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }
            if (resource !== undefined) {
                localVarQueryParameter['resource'] = resource;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the role identified by id
         * @param {string} roleId The ID or fullname associated to the role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleGetById: (roleId_1, human_1, ...args_1) => __awaiter(this, [roleId_1, human_1, ...args_1], void 0, function* (roleId, human, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleGetById', 'roleId', roleId);
            const localVarPath = `/v1/role/{role_id}`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Check access to the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleHeadById: (roleId_1, human_1, ...args_1) => __awaiter(this, [roleId_1, human_1, ...args_1], void 0, function* (roleId, human, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleHeadById', 'roleId', roleId);
            const localVarPath = `/v1/role/{role_id}`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'HEAD' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get jobs created by the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleJobGet: (roleId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [roleId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (roleId, limit, offset, order, permission, q, human, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleJobGet', 'roleId', roleId);
            const localVarPath = `/v1/role/{role_id}/job`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get runs of jobs created by the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleJobRunGet: (roleId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [roleId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (roleId, limit, offset, order, permission, q, human, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleJobRunGet', 'roleId', roleId);
            const localVarPath = `/v1/role/{role_id}/job_run`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete a key in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {string} accessKey The ID or fullname of the role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleKeyDelete: (roleId_1, accessKey_1, ...args_1) => __awaiter(this, [roleId_1, accessKey_1, ...args_1], void 0, function* (roleId, accessKey, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleKeyDelete', 'roleId', roleId);
            // verify required parameter 'accessKey' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleKeyDelete', 'accessKey', accessKey);
            const localVarPath = `/v1/role/{role_id}/key/{access_key}`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)))
                .replace(`{${"access_key"}}`, encodeURIComponent(String(accessKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get keys in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleKeyGet: (roleId_1, human_1, ...args_1) => __awaiter(this, [roleId_1, human_1, ...args_1], void 0, function* (roleId, human, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleKeyGet', 'roleId', roleId);
            const localVarPath = `/v1/role/{role_id}/key`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create a key in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {RoleKey} [roleKey]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleKeyPost: (roleId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, roleKey_1, ...args_1) => __awaiter(this, [roleId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, roleKey_1, ...args_1], void 0, function* (roleId, limit, offset, order, permission, q, human, roleKey, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleKeyPost', 'roleId', roleId);
            const localVarPath = `/v1/role/{role_id}/key`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(roleKey, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete a member in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {string} memberId The ID or fullname of the member
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleMemberDelete: (roleId_1, memberId_1, ...args_1) => __awaiter(this, [roleId_1, memberId_1, ...args_1], void 0, function* (roleId, memberId, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleMemberDelete', 'roleId', roleId);
            // verify required parameter 'memberId' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleMemberDelete', 'memberId', memberId);
            const localVarPath = `/v1/role/{role_id}/member/{member_id}`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)))
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get members in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {string} [type] Type of the resource to add (team or user)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleMemberGet: (roleId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, type_1, ...args_1) => __awaiter(this, [roleId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, type_1, ...args_1], void 0, function* (roleId, limit, offset, order, permission, q, human, type, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleMemberGet', 'roleId', roleId);
            const localVarPath = `/v1/role/{role_id}/member`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Post a member in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {string} memberId The ID or fullname of the member
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleMemberPost: (roleId_1, memberId_1, human_1, ...args_1) => __awaiter(this, [roleId_1, memberId_1, human_1, ...args_1], void 0, function* (roleId, memberId, human, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleMemberPost', 'roleId', roleId);
            // verify required parameter 'memberId' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleMemberPost', 'memberId', memberId);
            const localVarPath = `/v1/role/{role_id}/member/{member_id}`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)))
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete a policy in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {string} policyId The ID or fullname of the policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RolePolicyDelete: (roleId_1, policyId_1, ...args_1) => __awaiter(this, [roleId_1, policyId_1, ...args_1], void 0, function* (roleId, policyId, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RolePolicyDelete', 'roleId', roleId);
            // verify required parameter 'policyId' is not null or undefined
            (0, common_1.assertParamExists)('v1RolePolicyDelete', 'policyId', policyId);
            const localVarPath = `/v1/role/{role_id}/policy/{policy_id}`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)))
                .replace(`{${"policy_id"}}`, encodeURIComponent(String(policyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get policies in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [includeInactive] Includes policies that are no longer active
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RolePolicyGet: (roleId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, includeInactive_1, ...args_1) => __awaiter(this, [roleId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, includeInactive_1, ...args_1], void 0, function* (roleId, limit, offset, order, permission, q, human, includeInactive, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RolePolicyGet', 'roleId', roleId);
            const localVarPath = `/v1/role/{role_id}/policy`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (includeInactive !== undefined) {
                localVarQueryParameter['include-inactive'] = includeInactive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Post a policy in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {PolicyPost} [policyPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RolePolicyPost: (roleId_1, human_1, policyPost_1, ...args_1) => __awaiter(this, [roleId_1, human_1, policyPost_1, ...args_1], void 0, function* (roleId, human, policyPost, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RolePolicyPost', 'roleId', roleId);
            const localVarPath = `/v1/role/{role_id}/policy`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(policyPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {RolePost} [rolePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RolePutById: (roleId_1, human_1, rolePost_1, ...args_1) => __awaiter(this, [roleId_1, human_1, rolePost_1, ...args_1], void 0, function* (roleId, human, rolePost, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RolePutById', 'roleId', roleId);
            const localVarPath = `/v1/role/{role_id}`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rolePost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the service identified by id
         * @param {string} serviceId The ID or fullname associated to the service
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ServiceGetById: (serviceId_1, human_1, ...args_1) => __awaiter(this, [serviceId_1, human_1, ...args_1], void 0, function* (serviceId, human, options = {}) {
            // verify required parameter 'serviceId' is not null or undefined
            (0, common_1.assertParamExists)('v1ServiceGetById', 'serviceId', serviceId);
            const localVarPath = `/v1/service/{service_id}`
                .replace(`{${"service_id"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Check access to the service
         * @param {string} serviceId The ID or fullname of the service
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ServiceHeadById: (serviceId_1, human_1, ...args_1) => __awaiter(this, [serviceId_1, human_1, ...args_1], void 0, function* (serviceId, human, options = {}) {
            // verify required parameter 'serviceId' is not null or undefined
            (0, common_1.assertParamExists)('v1ServiceHeadById', 'serviceId', serviceId);
            const localVarPath = `/v1/service/{service_id}`
                .replace(`{${"service_id"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'HEAD' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get jobs created by the service
         * @param {string} serviceId The ID or fullname of the service
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ServiceJobGet: (serviceId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [serviceId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (serviceId, limit, offset, order, permission, q, human, options = {}) {
            // verify required parameter 'serviceId' is not null or undefined
            (0, common_1.assertParamExists)('v1ServiceJobGet', 'serviceId', serviceId);
            const localVarPath = `/v1/service/{service_id}/job`
                .replace(`{${"service_id"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get runs of jobs created by the service
         * @param {string} serviceId The ID or fullname of the service
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ServiceJobRunGet: (serviceId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [serviceId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (serviceId, limit, offset, order, permission, q, human, options = {}) {
            // verify required parameter 'serviceId' is not null or undefined
            (0, common_1.assertParamExists)('v1ServiceJobRunGet', 'serviceId', serviceId);
            const localVarPath = `/v1/service/{service_id}/job_run`
                .replace(`{${"service_id"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update service
         * @param {string} serviceId The ID or fullname of the service
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {ServicePost} [servicePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ServicePutById: (serviceId_1, human_1, servicePost_1, ...args_1) => __awaiter(this, [serviceId_1, human_1, servicePost_1, ...args_1], void 0, function* (serviceId, human, servicePost, options = {}) {
            // verify required parameter 'serviceId' is not null or undefined
            (0, common_1.assertParamExists)('v1ServicePutById', 'serviceId', serviceId);
            const localVarPath = `/v1/service/{service_id}`
                .replace(`{${"service_id"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(servicePost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create account in your account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {AccountPost} [accountPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShorcutAccountPost: (human_1, accountPost_1, ...args_1) => __awaiter(this, [human_1, accountPost_1, ...args_1], void 0, function* (human, accountPost, options = {}) {
            const localVarPath = `/v1/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accountPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create app in your organization
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {AppPost} [appPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShorcutAppPost: (human_1, appPost_1, ...args_1) => __awaiter(this, [human_1, appPost_1, ...args_1], void 0, function* (human, appPost, options = {}) {
            const localVarPath = `/v1/app`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(appPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create data on your account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {DataPost} [dataPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShorcutDataPost: (human_1, dataPost_1, ...args_1) => __awaiter(this, [human_1, dataPost_1, ...args_1], void 0, function* (human, dataPost, options = {}) {
            const localVarPath = `/v1/data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(dataPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create job on your account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {JobSpec} [jobSpec]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShorcutJobPost: (human_1, jobSpec_1, ...args_1) => __awaiter(this, [human_1, jobSpec_1, ...args_1], void 0, function* (human, jobSpec, options = {}) {
            const localVarPath = `/v1/job`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(jobSpec, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get runs of jobs in your account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShorcutJobRunGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, recursive, options = {}) {
            const localVarPath = `/v1/job_run`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get accounts in your organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutAccountGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, recursive, options = {}) {
            const localVarPath = `/v1/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get apps in your organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutAppGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, recursive, options = {}) {
            const localVarPath = `/v1/app`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get data on your account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutDataGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, recursive, options = {}) {
            const localVarPath = `/v1/data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get jobs in your account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutJobGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, recursive, options = {}) {
            const localVarPath = `/v1/job`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get private registries in your account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutPrivateRegistryGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, recursive, options = {}) {
            const localVarPath = `/v1/privateregistry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create private registry in your account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {PrivateregistryPost} [privateregistryPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutPrivateRegistryPost: (human_1, privateregistryPost_1, ...args_1) => __awaiter(this, [human_1, privateregistryPost_1, ...args_1], void 0, function* (human, privateregistryPost, options = {}) {
            const localVarPath = `/v1/privateregistry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(privateregistryPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get jobs in your account which are replica jobs
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutReplicasJobsGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, recursive, options = {}) {
            const localVarPath = `/v1/replica_jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get services in your account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutServiceGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, recursive, options = {}) {
            const localVarPath = `/v1/service`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create service in your account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {ServicePost} [servicePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutServicePost: (human_1, servicePost_1, ...args_1) => __awaiter(this, [human_1, servicePost_1, ...args_1], void 0, function* (human, servicePost, options = {}) {
            const localVarPath = `/v1/service`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(servicePost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get teams in your organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutTeamGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, options = {}) {
            const localVarPath = `/v1/team`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create team in your organization
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {Team} [team]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutTeamPost: (human_1, team_1, ...args_1) => __awaiter(this, [human_1, team_1, ...args_1], void 0, function* (human, team, options = {}) {
            const localVarPath = `/v1/team`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(team, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get users in your organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutUserGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, options = {}) {
            const localVarPath = `/v1/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create user in your organization
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {UserPost} [userPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutUserPost: (human_1, userPost_1, ...args_1) => __awaiter(this, [human_1, userPost_1, ...args_1], void 0, function* (human, userPost, options = {}) {
            const localVarPath = `/v1/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get swagger.json
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1SwaggerGetJson: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/v1/swagger.json`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the team identified by id
         * @param {string} teamId The ID or fullname associated to the team
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamGetById: (teamId_1, human_1, ...args_1) => __awaiter(this, [teamId_1, human_1, ...args_1], void 0, function* (teamId, human, options = {}) {
            // verify required parameter 'teamId' is not null or undefined
            (0, common_1.assertParamExists)('v1TeamGetById', 'teamId', teamId);
            const localVarPath = `/v1/team/{team_id}`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Check access to the team
         * @param {string} teamId The ID or fullname of the team
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamHeadById: (teamId_1, human_1, ...args_1) => __awaiter(this, [teamId_1, human_1, ...args_1], void 0, function* (teamId, human, options = {}) {
            // verify required parameter 'teamId' is not null or undefined
            (0, common_1.assertParamExists)('v1TeamHeadById', 'teamId', teamId);
            const localVarPath = `/v1/team/{team_id}`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'HEAD' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete a member in the team
         * @param {string} teamId The ID or fullname of the team
         * @param {string} memberId The ID or fullname of the member
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamMemberDelete: (teamId_1, memberId_1, ...args_1) => __awaiter(this, [teamId_1, memberId_1, ...args_1], void 0, function* (teamId, memberId, options = {}) {
            // verify required parameter 'teamId' is not null or undefined
            (0, common_1.assertParamExists)('v1TeamMemberDelete', 'teamId', teamId);
            // verify required parameter 'memberId' is not null or undefined
            (0, common_1.assertParamExists)('v1TeamMemberDelete', 'memberId', memberId);
            const localVarPath = `/v1/team/{team_id}/member/{member_id}`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get members in the team
         * @param {string} teamId The ID or fullname of the team
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {string} [type] Type of the resource to add (team or user)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamMemberGet: (teamId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, type_1, ...args_1) => __awaiter(this, [teamId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, type_1, ...args_1], void 0, function* (teamId, limit, offset, order, permission, q, human, type, options = {}) {
            // verify required parameter 'teamId' is not null or undefined
            (0, common_1.assertParamExists)('v1TeamMemberGet', 'teamId', teamId);
            const localVarPath = `/v1/team/{team_id}/member`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Post a member in the team
         * @param {string} teamId The ID or fullname of the team
         * @param {string} memberId The ID or fullname of the member
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamMemberPost: (teamId_1, memberId_1, human_1, ...args_1) => __awaiter(this, [teamId_1, memberId_1, human_1, ...args_1], void 0, function* (teamId, memberId, human, options = {}) {
            // verify required parameter 'teamId' is not null or undefined
            (0, common_1.assertParamExists)('v1TeamMemberPost', 'teamId', teamId);
            // verify required parameter 'memberId' is not null or undefined
            (0, common_1.assertParamExists)('v1TeamMemberPost', 'memberId', memberId);
            const localVarPath = `/v1/team/{team_id}/member/{member_id}`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete a policy in the team
         * @param {string} teamId The ID or fullname of the team
         * @param {string} policyId The ID or fullname of the policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamPolicyDelete: (teamId_1, policyId_1, ...args_1) => __awaiter(this, [teamId_1, policyId_1, ...args_1], void 0, function* (teamId, policyId, options = {}) {
            // verify required parameter 'teamId' is not null or undefined
            (0, common_1.assertParamExists)('v1TeamPolicyDelete', 'teamId', teamId);
            // verify required parameter 'policyId' is not null or undefined
            (0, common_1.assertParamExists)('v1TeamPolicyDelete', 'policyId', policyId);
            const localVarPath = `/v1/team/{team_id}/policy/{policy_id}`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"policy_id"}}`, encodeURIComponent(String(policyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get policies in the team
         * @param {string} teamId The ID or fullname of the team
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [includeInactive] Includes policies that are no longer active
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamPolicyGet: (teamId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, includeInactive_1, ...args_1) => __awaiter(this, [teamId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, includeInactive_1, ...args_1], void 0, function* (teamId, limit, offset, order, permission, q, human, includeInactive, options = {}) {
            // verify required parameter 'teamId' is not null or undefined
            (0, common_1.assertParamExists)('v1TeamPolicyGet', 'teamId', teamId);
            const localVarPath = `/v1/team/{team_id}/policy`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (includeInactive !== undefined) {
                localVarQueryParameter['include-inactive'] = includeInactive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Post a policy in the team
         * @param {string} teamId The ID or fullname of the team
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {PolicyPost} [policyPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamPolicyPost: (teamId_1, human_1, policyPost_1, ...args_1) => __awaiter(this, [teamId_1, human_1, policyPost_1, ...args_1], void 0, function* (teamId, human, policyPost, options = {}) {
            // verify required parameter 'teamId' is not null or undefined
            (0, common_1.assertParamExists)('v1TeamPolicyPost', 'teamId', teamId);
            const localVarPath = `/v1/team/{team_id}/policy`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(policyPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update team
         * @param {string} teamId The ID or fullname of the team
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {TeamPost} [teamPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamPutById: (teamId_1, human_1, teamPost_1, ...args_1) => __awaiter(this, [teamId_1, human_1, teamPost_1, ...args_1], void 0, function* (teamId, human, teamPost, options = {}) {
            // verify required parameter 'teamId' is not null or undefined
            (0, common_1.assertParamExists)('v1TeamPutById', 'teamId', teamId);
            const localVarPath = `/v1/team/{team_id}`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(teamPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get roles in the team
         * @param {string} teamId The ID or fullname of the team
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamRoleGet: (teamId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [teamId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (teamId, limit, offset, order, permission, q, human, options = {}) {
            // verify required parameter 'teamId' is not null or undefined
            (0, common_1.assertParamExists)('v1TeamRoleGet', 'teamId', teamId);
            const localVarPath = `/v1/team/{team_id}/role`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Post a role in the team
         * @param {string} teamId The ID or fullname of the team
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {RolePost} [rolePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamRolePost: (teamId_1, human_1, rolePost_1, ...args_1) => __awaiter(this, [teamId_1, human_1, rolePost_1, ...args_1], void 0, function* (teamId, human, rolePost, options = {}) {
            // verify required parameter 'teamId' is not null or undefined
            (0, common_1.assertParamExists)('v1TeamRolePost', 'teamId', teamId);
            const localVarPath = `/v1/team/{team_id}/role`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rolePost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Check permission (action & resource) for a given user
         * @param {string} action Expression (supporting wildcards) denoting the action(s) performed on the resource(s)
         * @param {string} resource URN-like expression (supporting wildcards) for matching resource(s)
         * @param {string} userId The ID or fullname of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserAllowedGet: (action_1, resource_1, userId_1, ...args_1) => __awaiter(this, [action_1, resource_1, userId_1, ...args_1], void 0, function* (action, resource, userId, options = {}) {
            // verify required parameter 'action' is not null or undefined
            (0, common_1.assertParamExists)('v1UserAllowedGet', 'action', action);
            // verify required parameter 'resource' is not null or undefined
            (0, common_1.assertParamExists)('v1UserAllowedGet', 'resource', resource);
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('v1UserAllowedGet', 'userId', userId);
            const localVarPath = `/v1/user/{user_id}/allowed`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }
            if (resource !== undefined) {
                localVarQueryParameter['resource'] = resource;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get apps for the user
         * @param {string} userId The ID or fullname of the user
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserAppGet: (userId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [userId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (userId, limit, offset, order, permission, q, human, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('v1UserAppGet', 'userId', userId);
            const localVarPath = `/v1/user/{user_id}/app`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the user identified by id
         * @param {string} userId The ID or fullname associated to the user
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserGetById: (userId_1, human_1, ...args_1) => __awaiter(this, [userId_1, human_1, ...args_1], void 0, function* (userId, human, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('v1UserGetById', 'userId', userId);
            const localVarPath = `/v1/user/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Check access to the user
         * @param {string} userId The ID or fullname of the user
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserHeadById: (userId_1, human_1, ...args_1) => __awaiter(this, [userId_1, human_1, ...args_1], void 0, function* (userId, human, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('v1UserHeadById', 'userId', userId);
            const localVarPath = `/v1/user/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'HEAD' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get jobs created by the user
         * @param {string} userId The ID or fullname of the user
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserJobGet: (userId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [userId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (userId, limit, offset, order, permission, q, human, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('v1UserJobGet', 'userId', userId);
            const localVarPath = `/v1/user/{user_id}/job`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get job occupation statistics for a user
         * @param {string} userId The ID or fullname of the user
         * @param {V1AccountJobOccupancyGetTypeParameter} [type] Get occupancy statistics by day, week, month, or year
         * @param {string} [from] date (YYYY-MM-DD)
         * @param {string} [to] date (YYYY-MM-DD)
         * @param {number} [noNull] When set to 1, the dates without data are omitted from the reply.
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserJobOccupancyGet: (userId_1, type_1, from_1, to_1, noNull_1, limit_1, offset_1, order_1, ...args_1) => __awaiter(this, [userId_1, type_1, from_1, to_1, noNull_1, limit_1, offset_1, order_1, ...args_1], void 0, function* (userId, type, from, to, noNull, limit, offset, order, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('v1UserJobOccupancyGet', 'userId', userId);
            const localVarPath = `/v1/user/{user_id}/job_occupancy`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            if (noNull !== undefined) {
                localVarQueryParameter['no_null'] = noNull;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get runs of jobs created by the user
         * @param {string} userId The ID or fullname of the user
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserJobRunGet: (userId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [userId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (userId, limit, offset, order, permission, q, human, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('v1UserJobRunGet', 'userId', userId);
            const localVarPath = `/v1/user/{user_id}/job_run`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete a policy in the user
         * @param {string} userId The ID or fullname of the user
         * @param {string} policyId The ID or fullname of the policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserPolicyDelete: (userId_1, policyId_1, ...args_1) => __awaiter(this, [userId_1, policyId_1, ...args_1], void 0, function* (userId, policyId, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('v1UserPolicyDelete', 'userId', userId);
            // verify required parameter 'policyId' is not null or undefined
            (0, common_1.assertParamExists)('v1UserPolicyDelete', 'policyId', policyId);
            const localVarPath = `/v1/user/{user_id}/policy/{policy_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"policy_id"}}`, encodeURIComponent(String(policyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get policies in the user
         * @param {string} userId The ID or fullname of the user
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {number} [includeInactive] Includes policies that are no longer active
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserPolicyGet: (userId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, includeInactive_1, ...args_1) => __awaiter(this, [userId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, includeInactive_1, ...args_1], void 0, function* (userId, limit, offset, order, permission, q, human, recursive, includeInactive, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('v1UserPolicyGet', 'userId', userId);
            const localVarPath = `/v1/user/{user_id}/policy`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            if (includeInactive !== undefined) {
                localVarQueryParameter['include-inactive'] = includeInactive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Post a policy in the user
         * @param {string} userId The ID or fullname of the user
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {PolicyPost} [policyPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserPolicyPost: (userId_1, human_1, policyPost_1, ...args_1) => __awaiter(this, [userId_1, human_1, policyPost_1, ...args_1], void 0, function* (userId, human, policyPost, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('v1UserPolicyPost', 'userId', userId);
            const localVarPath = `/v1/user/{user_id}/policy`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(policyPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update user
         * @param {string} userId The ID or fullname of the user
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {UserPost} [userPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserPutById: (userId_1, human_1, userPost_1, ...args_1) => __awaiter(this, [userId_1, human_1, userPost_1, ...args_1], void 0, function* (userId, human, userPost, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('v1UserPutById', 'userId', userId);
            const localVarPath = `/v1/user/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all jobs created by the user which are replica jobs
         * @param {string} userId The ID or fullname of the user
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserReplicaJobsGet: (userId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [userId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (userId, limit, offset, order, permission, q, human, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('v1UserReplicaJobsGet', 'userId', userId);
            const localVarPath = `/v1/user/{user_id}/replica_jobs`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get terms of the organization of the user
         * @param {string} userId The ID or fullname of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserTermsGet: (userId_1, ...args_1) => __awaiter(this, [userId_1, ...args_1], void 0, function* (userId, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('v1UserTermsGet', 'userId', userId);
            const localVarPath = `/v1/user/{user_id}/terms`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Set terms as readed for the user
         * @param {string} userId The ID or fullname of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserTermsPut: (userId_1, ...args_1) => __awaiter(this, [userId_1, ...args_1], void 0, function* (userId, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('v1UserTermsPut', 'userId', userId);
            const localVarPath = `/v1/user/{user_id}/terms`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the users and roles that have permission to perform the given action(s) on the given resource(s)
         * @param {string} resource URN-like expression (supporting wildcards) for matching resource(s)
         * @param {string} action Expression (supporting wildcards) denoting the action(s) performed on the resource(s)
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1WhoIsAllowedGet: (resource_1, action_1, limit_1, offset_1, order_1, q_1, human_1, ...args_1) => __awaiter(this, [resource_1, action_1, limit_1, offset_1, order_1, q_1, human_1, ...args_1], void 0, function* (resource, action, limit, offset, order, q, human, options = {}) {
            // verify required parameter 'resource' is not null or undefined
            (0, common_1.assertParamExists)('v1WhoIsAllowedGet', 'resource', resource);
            // verify required parameter 'action' is not null or undefined
            (0, common_1.assertParamExists)('v1WhoIsAllowedGet', 'action', action);
            const localVarPath = `/v1/who_is_allowed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (resource !== undefined) {
                localVarQueryParameter['resource'] = resource;
            }
            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.ToolkitApiAxiosParamCreator = ToolkitApiAxiosParamCreator;
/**
 * ToolkitApi - functional programming interface
 * @export
 */
const ToolkitApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ToolkitApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get apps in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountAppGet(accountId, limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountAppGet(accountId, limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1AccountAppGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create app in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {AppPost} [appPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountAppPost(accountId, human, appPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountAppPost(accountId, human, appPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1AccountAppPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get data in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountDataGet(accountId, limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountDataGet(accountId, limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1AccountDataGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create data in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {DataPost} [dataPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountDataPost(accountId, human, dataPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountDataPost(accountId, human, dataPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1AccountDataPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get accounts in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountGet(accountId, limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountGet(accountId, limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1AccountGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountGetById(accountId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountGetById(accountId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1AccountGetById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Check access to the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountHeadById(accountId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountHeadById(accountId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1AccountHeadById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get jobs in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobGet(accountId, limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountJobGet(accountId, limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1AccountJobGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get job occupation statistics for an account
         * @param {string} accountId The ID or fullname of the account
         * @param {V1AccountJobOccupancyGetTypeParameter} [type] Get occupancy statistics by day, week, month, or year
         * @param {string} [from] date (YYYY-MM-DD)
         * @param {string} [to] date (YYYY-MM-DD)
         * @param {number} [noNull] When set to 1, the dates without data are omitted from the reply.
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobOccupancyGet(accountId, type, from, to, noNull, limit, offset, order, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountJobOccupancyGet(accountId, type, from, to, noNull, limit, offset, order, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1AccountJobOccupancyGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create job in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {JobSpec} [jobSpec]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobPost(accountId, human, jobSpec, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountJobPost(accountId, human, jobSpec, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1AccountJobPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get runs of jobs in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobRunGet(accountId, limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountJobRunGet(accountId, limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1AccountJobRunGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create account in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {AccountPost} [accountPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountPost(accountId, human, accountPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountPost(accountId, human, accountPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1AccountPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {AccountPost} [accountPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountPutById(accountId, human, accountPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountPutById(accountId, human, accountPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1AccountPutById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get all jobs in the account which are replica jobs
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountReplicaJobsGet(accountId, limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountReplicaJobsGet(accountId, limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1AccountReplicaJobsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get policies in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountRoleGet(accountId, limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountRoleGet(accountId, limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1AccountRoleGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create role in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {RolePost} [rolePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountRolePost(accountId, human, rolePost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountRolePost(accountId, human, rolePost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1AccountRolePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get services in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountServiceGet(accountId, limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountServiceGet(accountId, limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1AccountServiceGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create service in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {ServicePost} [servicePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountServicePost(accountId, human, servicePost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountServicePost(accountId, human, servicePost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1AccountServicePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary List allowed operations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AllowedOperationGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AllowedOperationGet(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1AllowedOperationGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Check permission (action & resource) for a given user or role (defaults to yourself)
         * @param {Allowed} [allowed]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AllowedPost(allowed, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AllowedPost(allowed, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1AllowedPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Delete app
         * @param {string} appId The ID or fullname of the app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AppDeleteById(appId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AppDeleteById(appId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1AppDeleteById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get app
         * @param {string} appId The ID or fullname of the app
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AppGetById(appId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AppGetById(appId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1AppGetById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Check access to the app
         * @param {string} appId The ID or fullname of the app
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AppHeadById(appId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AppHeadById(appId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1AppHeadById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update app
         * @param {string} appId The ID or fullname of the app
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {AppPost} [appPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AppPutById(appId, human, appPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AppPutById(appId, human, appPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1AppPutById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get accounts in the cluster
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterAccountGet(limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ClusterAccountGet(limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ClusterAccountGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get apps in the cluster
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterAppGet(limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ClusterAppGet(limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ClusterAppGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get data in the cluster
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterDataGet(limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ClusterDataGet(limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ClusterDataGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get jobs in the cluster
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterJobGet(limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ClusterJobGet(limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ClusterJobGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get job occupation statistics in the cluster
         * @param {V1AccountJobOccupancyGetTypeParameter} [type] Get occupancy statistics by day, week, month, or year
         * @param {string} [from] date (YYYY-MM-DD)
         * @param {string} [to] date (YYYY-MM-DD)
         * @param {number} [noNull] When set to 1, the dates without data are omitted from the reply.
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterJobOccupancyGet(type, from, to, noNull, limit, offset, order, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ClusterJobOccupancyGet(type, from, to, noNull, limit, offset, order, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ClusterJobOccupancyGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get runs of jobs in the cluster
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterJobRunGet(limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ClusterJobRunGet(limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ClusterJobRunGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get private registries in the cluster
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterPrivateRegistryGet(limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ClusterPrivateRegistryGet(limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ClusterPrivateRegistryGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get roles in the cluster
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterRoleGet(limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ClusterRoleGet(limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ClusterRoleGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get services in the cluster
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterServiceGet(limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ClusterServiceGet(limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ClusterServiceGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get teams in the cluster
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterTeamGet(limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ClusterTeamGet(limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ClusterTeamGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get users in the cluster
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterUserGet(limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ClusterUserGet(limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ClusterUserGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Commit a data and create a version and optionaly a tag
         * @param {string} dataId The ID or fullname associated to the data
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {string} [tag] Data tag to use
         * @param {string} [version] Data version to use
         * @param {Data} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataCommitPost(dataId, human, tag, version, data, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1DataCommitPost(dataId, human, tag, version, data, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1DataCommitPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Download a data
         * @param {string} dataId The ID or fullname associated to the data
         * @param {string} [version] Data version to use
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataDownloadGet(dataId, version, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1DataDownloadGet(dataId, version, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1DataDownloadGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get the data identified by id
         * @param {string} dataId The ID or fullname associated to the data
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataGetById(dataId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1DataGetById(dataId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1DataGetById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Check access to the data
         * @param {string} dataId The ID or fullname of the data
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataHeadById(dataId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1DataHeadById(dataId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1DataHeadById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Check if a data is using dataV2
         * @param {string} dataId The ID or fullname associated to the data
         * @param {string} [version] Data version to use
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataIsV2Get(dataId, version, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1DataIsV2Get(dataId, version, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1DataIsV2Get']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Check if a data is using dataV2. Return \'true\' or \'false\'
         * @param {string} dataId The ID or fullname associated to the data
         * @param {string} [version] Data version to use
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataListGet(dataId, version, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1DataListGet(dataId, version, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1DataListGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Pull data
         * @param {string} dataId The ID or fullname associated to the data
         * @param {string} [version] Data version to use
         * @param {string} [mapping] Path of the remote path and local path. Can specify immutable/mutable version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataPullGet(dataId, version, mapping, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1DataPullGet(dataId, version, mapping, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1DataPullGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Push data
         * @param {string} chunk Chunk ID pushed
         * @param {string} dataId The ID or fullname associated to the data
         * @param {string} [version] Data version to use
         * @param {string} [state] State to resume push
         * @param {File} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataPushPost(chunk, dataId, version, state, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1DataPushPost(chunk, dataId, version, state, body, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1DataPushPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update data
         * @param {string} dataId The ID or fullname of the data
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {DataPost} [dataPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataPutById(dataId, human, dataPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1DataPutById(dataId, human, dataPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1DataPutById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Return data tree
         * @param {string} dataId The ID or fullname associated to the data
         * @param {string} [version] Data version to use
         * @param {string} [kind] Kind to display data tree: ls or tree
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataTreeGet(dataId, version, kind, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1DataTreeGet(dataId, version, kind, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1DataTreeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update data version
         * @param {string} dataId The ID or fullname associated to the data
         * @param {string} version Data version to use
         * @param {Data} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataUpdatePost(dataId, version, data, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1DataUpdatePost(dataId, version, data, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1DataUpdatePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Upload data
         * @param {string} chunk Chunk ID pushed
         * @param {string} dataId The ID or fullname associated to the data
         * @param {string} [version] Data version to use
         * @param {string} [state] State to resume push
         * @param {File} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataUploadPost(chunk, dataId, version, state, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1DataUploadPost(chunk, dataId, version, state, body, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1DataUploadPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update bid of the job
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {JobRebid} [jobRebid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobBidPut(jobId, human, jobRebid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1JobBidPut(jobId, human, jobRebid, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1JobBidPut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get process agent children of the job
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobChildrenGet(jobId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1JobChildrenGet(jobId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1JobChildrenGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Check if job is consented
         * @param {string} jobId The ID or fullname associated to the job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobConsentHead(jobId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1JobConsentHead(jobId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1JobConsentHead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Consent to job scopes
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobConsentPost(jobId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1JobConsentPost(jobId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1JobConsentPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Cancel (a.k.a. kill) a queued, queuing or running job
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobDeleteById(jobId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1JobDeleteById(jobId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1JobDeleteById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Execute a command in a running job
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobExecGet(jobId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1JobExecGet(jobId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1JobExecGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get job information
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobGetById(jobId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1JobGetById(jobId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1JobGetById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Check access to the job
         * @param {string} jobId The ID or fullname of the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobHeadById(jobId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1JobHeadById(jobId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1JobHeadById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Return logs of a job
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [follow] WebSocket will continue to receive new logs if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobLogsGet(jobId, follow, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1JobLogsGet(jobId, follow, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1JobLogsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Return logs of a job for a given run
         * @param {string} jobId The ID or fullname associated to the job
         * @param {string} runId ID of the run
         * @param {number} [follow] WebSocket will continue to receive new logs if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobLogsRunGet(jobId, runId, follow, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1JobLogsRunGet(jobId, runId, follow, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1JobLogsRunGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update job info like name, owner, etc
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {Job} [job]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobPutById(jobId, human, job, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1JobPutById(jobId, human, job, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1JobPutById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Retry an interrupted, failed or cancelled job
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobRetryPut(jobId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1JobRetryPut(jobId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1JobRetryPut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Check permission (action & resource) for your user or role
         * @param {string} action Expression (supporting wildcards) denoting the action(s) performed on the resource(s)
         * @param {string} resource URN-like expression (supporting wildcards) for matching resource(s)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeAllowedGet(action, resource, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1MeAllowedGet(action, resource, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1MeAllowedGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get apps for your user
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeAppGet(limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1MeAppGet(limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1MeAppGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get your user/role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeGet(human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1MeGet(human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1MeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get jobs created by your user/role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeJobGet(limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1MeJobGet(limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1MeJobGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get job occupation statistics for your user/role
         * @param {V1AccountJobOccupancyGetTypeParameter} [type] Get occupancy statistics by day, week, month, or year
         * @param {string} [from] date (YYYY-MM-DD)
         * @param {string} [to] date (YYYY-MM-DD)
         * @param {number} [noNull] When set to 1, the dates without data are omitted from the reply.
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeJobOccupancyGet(type, from, to, noNull, limit, offset, order, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1MeJobOccupancyGet(type, from, to, noNull, limit, offset, order, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1MeJobOccupancyGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get runs of jobs created by your user/role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeJobRunGet(limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1MeJobRunGet(limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1MeJobRunGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Delete a policy in your user/role
         * @param {string} policyId The ID or fullname of the policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MePolicyDelete(policyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1MePolicyDelete(policyId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1MePolicyDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get policies in your user/role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MePolicyGet(limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1MePolicyGet(limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1MePolicyGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Post a policy in your user/role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {PolicyPost} [policyPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MePolicyPost(human, policyPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1MePolicyPost(human, policyPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1MePolicyPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update your user/role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {UserOrRolePost} [userOrRolePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MePut(human, userOrRolePost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1MePut(human, userOrRolePost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1MePut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get terms of the organization of your user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeTermsGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1MeTermsGet(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1MeTermsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Set terms as readed for your user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeTermsPut(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1MeTermsPut(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1MeTermsPut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get accounts in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationAccountGet(organizationId, limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1OrganizationAccountGet(organizationId, limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1OrganizationAccountGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create account in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {AccountPost} [accountPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationAccountPost(organizationId, human, accountPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1OrganizationAccountPost(organizationId, human, accountPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1OrganizationAccountPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get apps in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationAppGet(organizationId, limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1OrganizationAppGet(organizationId, limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1OrganizationAppGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create app in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {AppPost} [appPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationAppPost(organizationId, human, appPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1OrganizationAppPost(organizationId, human, appPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1OrganizationAppPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get data in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationDataGet(organizationId, limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1OrganizationDataGet(organizationId, limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1OrganizationDataGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get organizations
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationGet(limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1OrganizationGet(limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1OrganizationGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get the organization identified by id
         * @param {string} organizationId The ID or fullname associated to the organization
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationGetById(organizationId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1OrganizationGetById(organizationId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1OrganizationGetById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Check access to the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationHeadById(organizationId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1OrganizationHeadById(organizationId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1OrganizationHeadById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get jobs in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationJobGet(organizationId, limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1OrganizationJobGet(organizationId, limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1OrganizationJobGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get job occupation statistics for an organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {V1AccountJobOccupancyGetTypeParameter} [type] Get occupancy statistics by day, week, month, or year
         * @param {string} [from] date (YYYY-MM-DD)
         * @param {string} [to] date (YYYY-MM-DD)
         * @param {number} [noNull] When set to 1, the dates without data are omitted from the reply.
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationJobOccupancyGet(organizationId, type, from, to, noNull, limit, offset, order, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1OrganizationJobOccupancyGet(organizationId, type, from, to, noNull, limit, offset, order, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1OrganizationJobOccupancyGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get runs of jobs in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationJobRunGet(organizationId, limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1OrganizationJobRunGet(organizationId, limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1OrganizationJobRunGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create organization
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {OrganizationPost} [organizationPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationPost(human, organizationPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1OrganizationPost(human, organizationPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1OrganizationPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {OrganizationPost} [organizationPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationPutById(organizationId, human, organizationPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1OrganizationPutById(organizationId, human, organizationPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1OrganizationPutById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get all jobs in the organization which are replica jobs
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationReplicaJobsGet(organizationId, limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1OrganizationReplicaJobsGet(organizationId, limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1OrganizationReplicaJobsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get roles in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationRoleGet(organizationId, limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1OrganizationRoleGet(organizationId, limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1OrganizationRoleGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create role in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {RolePost} [rolePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationRolePost(organizationId, human, rolePost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1OrganizationRolePost(organizationId, human, rolePost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1OrganizationRolePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get services in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationServiceGet(organizationId, limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1OrganizationServiceGet(organizationId, limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1OrganizationServiceGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get teams in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationTeamGet(organizationId, limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1OrganizationTeamGet(organizationId, limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1OrganizationTeamGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create team in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {TeamPost} [teamPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationTeamPost(organizationId, human, teamPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1OrganizationTeamPost(organizationId, human, teamPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1OrganizationTeamPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get users in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationUserGet(organizationId, limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1OrganizationUserGet(organizationId, limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1OrganizationUserGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create user in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {UserPost} [userPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationUserPost(organizationId, human, userPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1OrganizationUserPost(organizationId, human, userPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1OrganizationUserPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get the private registry identified by id
         * @param {string} privateregistryId The ID or fullname associated to the private registry
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PrivateRegistryGetById(privateregistryId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1PrivateRegistryGetById(privateregistryId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1PrivateRegistryGetById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Check access to the privateregistry
         * @param {string} privateregistryId The ID or fullname of the private registry
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PrivateRegistryHeadById(privateregistryId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1PrivateRegistryHeadById(privateregistryId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1PrivateRegistryHeadById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update private registry
         * @param {string} privateregistryId The ID or fullname of the private registry
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {PrivateregistryPost} [privateregistryPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PrivateRegistryPutById(privateregistryId, human, privateregistryPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1PrivateRegistryPutById(privateregistryId, human, privateregistryPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1PrivateRegistryPutById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Cancel ReplicaJobs via replicaGroupId
         * @param {string} replicaGroupId The replicaGroupId of the ReplicaJobs
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ReplicaJobsDeleteByReplicaGroupId(replicaGroupId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ReplicaJobsDeleteByReplicaGroupId(replicaGroupId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ReplicaJobsDeleteByReplicaGroupId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get ReplicaJobs via replicaGroupId
         * @param {string} replicaGroupId The replicaGroupId of the ReplicaJobs
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ReplicaJobsGetByReplicaGroupId(replicaGroupId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ReplicaJobsGetByReplicaGroupId(replicaGroupId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ReplicaJobsGetByReplicaGroupId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Check access to the ReplicaJobs via replicaGroupId
         * @param {string} replicaGroupId The replicaGroupId of the ReplicaJobs
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ReplicaJobsHeadByReplicaGroupId(replicaGroupId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ReplicaJobsHeadByReplicaGroupId(replicaGroupId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ReplicaJobsHeadByReplicaGroupId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Check permission (action & resource) for a given user or role
         * @param {string} resourceId The ID or fullname of the resource
         * @param {string} action Expression (supporting wildcards) denoting the action(s) performed on the resource(s)
         * @param {string} resource URN-like expression (supporting wildcards) for matching resource(s)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ResourceAllowedGet(resourceId, action, resource, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ResourceAllowedGet(resourceId, action, resource, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ResourceAllowedGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get resource
         * @param {string} resourceId The ID or fullname of the resource
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ResourceGetById(resourceId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ResourceGetById(resourceId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ResourceGetById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Check access to the resource
         * @param {string} resourceId The ID or fullname of the resource
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ResourceHeadById(resourceId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ResourceHeadById(resourceId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ResourceHeadById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Resolve a resource id
         * @param {string} resourceId The ID or fullname of the resource
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ResourceIdGet(resourceId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ResourceIdGet(resourceId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ResourceIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get roles in the resource
         * @param {string} resourceId The ID or fullname of the resource
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ResourceRoleGet(resourceId, limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ResourceRoleGet(resourceId, limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ResourceRoleGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create role in the resource
         * @param {string} resourceId The ID or fullname of the resource
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {RolePost} [rolePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ResourceRolePost(resourceId, human, rolePost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ResourceRolePost(resourceId, human, rolePost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ResourceRolePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Check permission (action & resource) for a given role
         * @param {string} action Expression (supporting wildcards) denoting the action(s) performed on the resource(s)
         * @param {string} resource URN-like expression (supporting wildcards) for matching resource(s)
         * @param {string} roleId The ID or fullname of the role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleAllowedGet(action, resource, roleId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RoleAllowedGet(action, resource, roleId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1RoleAllowedGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get the role identified by id
         * @param {string} roleId The ID or fullname associated to the role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleGetById(roleId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RoleGetById(roleId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1RoleGetById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Check access to the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleHeadById(roleId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RoleHeadById(roleId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1RoleHeadById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get jobs created by the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleJobGet(roleId, limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RoleJobGet(roleId, limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1RoleJobGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get runs of jobs created by the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleJobRunGet(roleId, limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RoleJobRunGet(roleId, limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1RoleJobRunGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Delete a key in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {string} accessKey The ID or fullname of the role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleKeyDelete(roleId, accessKey, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RoleKeyDelete(roleId, accessKey, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1RoleKeyDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get keys in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleKeyGet(roleId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RoleKeyGet(roleId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1RoleKeyGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create a key in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {RoleKey} [roleKey]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleKeyPost(roleId, limit, offset, order, permission, q, human, roleKey, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RoleKeyPost(roleId, limit, offset, order, permission, q, human, roleKey, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1RoleKeyPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Delete a member in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {string} memberId The ID or fullname of the member
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleMemberDelete(roleId, memberId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RoleMemberDelete(roleId, memberId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1RoleMemberDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get members in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {string} [type] Type of the resource to add (team or user)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleMemberGet(roleId, limit, offset, order, permission, q, human, type, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RoleMemberGet(roleId, limit, offset, order, permission, q, human, type, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1RoleMemberGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Post a member in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {string} memberId The ID or fullname of the member
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleMemberPost(roleId, memberId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RoleMemberPost(roleId, memberId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1RoleMemberPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Delete a policy in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {string} policyId The ID or fullname of the policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RolePolicyDelete(roleId, policyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RolePolicyDelete(roleId, policyId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1RolePolicyDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get policies in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [includeInactive] Includes policies that are no longer active
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RolePolicyGet(roleId, limit, offset, order, permission, q, human, includeInactive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RolePolicyGet(roleId, limit, offset, order, permission, q, human, includeInactive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1RolePolicyGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Post a policy in the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {PolicyPost} [policyPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RolePolicyPost(roleId, human, policyPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RolePolicyPost(roleId, human, policyPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1RolePolicyPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {RolePost} [rolePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RolePutById(roleId, human, rolePost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RolePutById(roleId, human, rolePost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1RolePutById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get the service identified by id
         * @param {string} serviceId The ID or fullname associated to the service
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ServiceGetById(serviceId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ServiceGetById(serviceId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ServiceGetById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Check access to the service
         * @param {string} serviceId The ID or fullname of the service
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ServiceHeadById(serviceId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ServiceHeadById(serviceId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ServiceHeadById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get jobs created by the service
         * @param {string} serviceId The ID or fullname of the service
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ServiceJobGet(serviceId, limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ServiceJobGet(serviceId, limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ServiceJobGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get runs of jobs created by the service
         * @param {string} serviceId The ID or fullname of the service
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ServiceJobRunGet(serviceId, limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ServiceJobRunGet(serviceId, limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ServiceJobRunGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update service
         * @param {string} serviceId The ID or fullname of the service
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {ServicePost} [servicePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ServicePutById(serviceId, human, servicePost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ServicePutById(serviceId, human, servicePost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ServicePutById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create account in your account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {AccountPost} [accountPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShorcutAccountPost(human, accountPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ShorcutAccountPost(human, accountPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ShorcutAccountPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create app in your organization
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {AppPost} [appPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShorcutAppPost(human, appPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ShorcutAppPost(human, appPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ShorcutAppPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create data on your account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {DataPost} [dataPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShorcutDataPost(human, dataPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ShorcutDataPost(human, dataPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ShorcutDataPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create job on your account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {JobSpec} [jobSpec]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShorcutJobPost(human, jobSpec, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ShorcutJobPost(human, jobSpec, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ShorcutJobPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get runs of jobs in your account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShorcutJobRunGet(limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ShorcutJobRunGet(limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ShorcutJobRunGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get accounts in your organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutAccountGet(limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ShortcutAccountGet(limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ShortcutAccountGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get apps in your organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutAppGet(limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ShortcutAppGet(limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ShortcutAppGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get data on your account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutDataGet(limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ShortcutDataGet(limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ShortcutDataGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get jobs in your account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutJobGet(limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ShortcutJobGet(limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ShortcutJobGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get private registries in your account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutPrivateRegistryGet(limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ShortcutPrivateRegistryGet(limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ShortcutPrivateRegistryGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create private registry in your account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {PrivateregistryPost} [privateregistryPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutPrivateRegistryPost(human, privateregistryPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ShortcutPrivateRegistryPost(human, privateregistryPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ShortcutPrivateRegistryPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get jobs in your account which are replica jobs
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutReplicasJobsGet(limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ShortcutReplicasJobsGet(limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ShortcutReplicasJobsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get services in your account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutServiceGet(limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ShortcutServiceGet(limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ShortcutServiceGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create service in your account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {ServicePost} [servicePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutServicePost(human, servicePost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ShortcutServicePost(human, servicePost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ShortcutServicePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get teams in your organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutTeamGet(limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ShortcutTeamGet(limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ShortcutTeamGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create team in your organization
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {Team} [team]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutTeamPost(human, team, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ShortcutTeamPost(human, team, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ShortcutTeamPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get users in your organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutUserGet(limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ShortcutUserGet(limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ShortcutUserGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create user in your organization
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {UserPost} [userPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutUserPost(human, userPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ShortcutUserPost(human, userPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1ShortcutUserPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get swagger.json
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1SwaggerGetJson(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1SwaggerGetJson(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1SwaggerGetJson']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get the team identified by id
         * @param {string} teamId The ID or fullname associated to the team
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamGetById(teamId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1TeamGetById(teamId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1TeamGetById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Check access to the team
         * @param {string} teamId The ID or fullname of the team
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamHeadById(teamId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1TeamHeadById(teamId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1TeamHeadById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Delete a member in the team
         * @param {string} teamId The ID or fullname of the team
         * @param {string} memberId The ID or fullname of the member
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamMemberDelete(teamId, memberId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1TeamMemberDelete(teamId, memberId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1TeamMemberDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get members in the team
         * @param {string} teamId The ID or fullname of the team
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {string} [type] Type of the resource to add (team or user)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamMemberGet(teamId, limit, offset, order, permission, q, human, type, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1TeamMemberGet(teamId, limit, offset, order, permission, q, human, type, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1TeamMemberGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Post a member in the team
         * @param {string} teamId The ID or fullname of the team
         * @param {string} memberId The ID or fullname of the member
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamMemberPost(teamId, memberId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1TeamMemberPost(teamId, memberId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1TeamMemberPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Delete a policy in the team
         * @param {string} teamId The ID or fullname of the team
         * @param {string} policyId The ID or fullname of the policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamPolicyDelete(teamId, policyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1TeamPolicyDelete(teamId, policyId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1TeamPolicyDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get policies in the team
         * @param {string} teamId The ID or fullname of the team
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [includeInactive] Includes policies that are no longer active
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamPolicyGet(teamId, limit, offset, order, permission, q, human, includeInactive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1TeamPolicyGet(teamId, limit, offset, order, permission, q, human, includeInactive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1TeamPolicyGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Post a policy in the team
         * @param {string} teamId The ID or fullname of the team
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {PolicyPost} [policyPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamPolicyPost(teamId, human, policyPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1TeamPolicyPost(teamId, human, policyPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1TeamPolicyPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update team
         * @param {string} teamId The ID or fullname of the team
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {TeamPost} [teamPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamPutById(teamId, human, teamPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1TeamPutById(teamId, human, teamPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1TeamPutById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get roles in the team
         * @param {string} teamId The ID or fullname of the team
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamRoleGet(teamId, limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1TeamRoleGet(teamId, limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1TeamRoleGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Post a role in the team
         * @param {string} teamId The ID or fullname of the team
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {RolePost} [rolePost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamRolePost(teamId, human, rolePost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1TeamRolePost(teamId, human, rolePost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1TeamRolePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Check permission (action & resource) for a given user
         * @param {string} action Expression (supporting wildcards) denoting the action(s) performed on the resource(s)
         * @param {string} resource URN-like expression (supporting wildcards) for matching resource(s)
         * @param {string} userId The ID or fullname of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserAllowedGet(action, resource, userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1UserAllowedGet(action, resource, userId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1UserAllowedGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get apps for the user
         * @param {string} userId The ID or fullname of the user
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserAppGet(userId, limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1UserAppGet(userId, limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1UserAppGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get the user identified by id
         * @param {string} userId The ID or fullname associated to the user
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserGetById(userId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1UserGetById(userId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1UserGetById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Check access to the user
         * @param {string} userId The ID or fullname of the user
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserHeadById(userId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1UserHeadById(userId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1UserHeadById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get jobs created by the user
         * @param {string} userId The ID or fullname of the user
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserJobGet(userId, limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1UserJobGet(userId, limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1UserJobGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get job occupation statistics for a user
         * @param {string} userId The ID or fullname of the user
         * @param {V1AccountJobOccupancyGetTypeParameter} [type] Get occupancy statistics by day, week, month, or year
         * @param {string} [from] date (YYYY-MM-DD)
         * @param {string} [to] date (YYYY-MM-DD)
         * @param {number} [noNull] When set to 1, the dates without data are omitted from the reply.
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserJobOccupancyGet(userId, type, from, to, noNull, limit, offset, order, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1UserJobOccupancyGet(userId, type, from, to, noNull, limit, offset, order, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1UserJobOccupancyGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get runs of jobs created by the user
         * @param {string} userId The ID or fullname of the user
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserJobRunGet(userId, limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1UserJobRunGet(userId, limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1UserJobRunGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Delete a policy in the user
         * @param {string} userId The ID or fullname of the user
         * @param {string} policyId The ID or fullname of the policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserPolicyDelete(userId, policyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1UserPolicyDelete(userId, policyId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1UserPolicyDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get policies in the user
         * @param {string} userId The ID or fullname of the user
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {number} [includeInactive] Includes policies that are no longer active
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserPolicyGet(userId, limit, offset, order, permission, q, human, recursive, includeInactive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1UserPolicyGet(userId, limit, offset, order, permission, q, human, recursive, includeInactive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1UserPolicyGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Post a policy in the user
         * @param {string} userId The ID or fullname of the user
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {PolicyPost} [policyPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserPolicyPost(userId, human, policyPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1UserPolicyPost(userId, human, policyPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1UserPolicyPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update user
         * @param {string} userId The ID or fullname of the user
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {UserPost} [userPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserPutById(userId, human, userPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1UserPutById(userId, human, userPost, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1UserPutById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get all jobs created by the user which are replica jobs
         * @param {string} userId The ID or fullname of the user
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserReplicaJobsGet(userId, limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1UserReplicaJobsGet(userId, limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1UserReplicaJobsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get terms of the organization of the user
         * @param {string} userId The ID or fullname of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserTermsGet(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1UserTermsGet(userId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1UserTermsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Set terms as readed for the user
         * @param {string} userId The ID or fullname of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserTermsPut(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1UserTermsPut(userId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1UserTermsPut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get the users and roles that have permission to perform the given action(s) on the given resource(s)
         * @param {string} resource URN-like expression (supporting wildcards) for matching resource(s)
         * @param {string} action Expression (supporting wildcards) denoting the action(s) performed on the resource(s)
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1WhoIsAllowedGet(resource, action, limit, offset, order, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1WhoIsAllowedGet(resource, action, limit, offset, order, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ToolkitApi.v1WhoIsAllowedGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.ToolkitApiFp = ToolkitApiFp;
/**
 * ToolkitApi - factory interface
 * @export
 */
const ToolkitApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ToolkitApiFp)(configuration);
    return {
        /**
         *
         * @summary Get apps in the account
         * @param {ToolkitApiV1AccountAppGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountAppGet(requestParameters, options) {
            return localVarFp.v1AccountAppGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create app in the account
         * @param {ToolkitApiV1AccountAppPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountAppPost(requestParameters, options) {
            return localVarFp.v1AccountAppPost(requestParameters.accountId, requestParameters.human, requestParameters.appPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get data in the account
         * @param {ToolkitApiV1AccountDataGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountDataGet(requestParameters, options) {
            return localVarFp.v1AccountDataGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create data in the account
         * @param {ToolkitApiV1AccountDataPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountDataPost(requestParameters, options) {
            return localVarFp.v1AccountDataPost(requestParameters.accountId, requestParameters.human, requestParameters.dataPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get accounts in the account
         * @param {ToolkitApiV1AccountGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountGet(requestParameters, options) {
            return localVarFp.v1AccountGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get account
         * @param {ToolkitApiV1AccountGetByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountGetById(requestParameters, options) {
            return localVarFp.v1AccountGetById(requestParameters.accountId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check access to the account
         * @param {ToolkitApiV1AccountHeadByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountHeadById(requestParameters, options) {
            return localVarFp.v1AccountHeadById(requestParameters.accountId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get jobs in the account
         * @param {ToolkitApiV1AccountJobGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobGet(requestParameters, options) {
            return localVarFp.v1AccountJobGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get job occupation statistics for an account
         * @param {ToolkitApiV1AccountJobOccupancyGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobOccupancyGet(requestParameters, options) {
            return localVarFp.v1AccountJobOccupancyGet(requestParameters.accountId, requestParameters.type, requestParameters.from, requestParameters.to, requestParameters.noNull, requestParameters.limit, requestParameters.offset, requestParameters.order, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create job in the account
         * @param {ToolkitApiV1AccountJobPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobPost(requestParameters, options) {
            return localVarFp.v1AccountJobPost(requestParameters.accountId, requestParameters.human, requestParameters.jobSpec, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get runs of jobs in the account
         * @param {ToolkitApiV1AccountJobRunGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobRunGet(requestParameters, options) {
            return localVarFp.v1AccountJobRunGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create account in the account
         * @param {ToolkitApiV1AccountPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountPost(requestParameters, options) {
            return localVarFp.v1AccountPost(requestParameters.accountId, requestParameters.human, requestParameters.accountPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update account
         * @param {ToolkitApiV1AccountPutByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountPutById(requestParameters, options) {
            return localVarFp.v1AccountPutById(requestParameters.accountId, requestParameters.human, requestParameters.accountPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all jobs in the account which are replica jobs
         * @param {ToolkitApiV1AccountReplicaJobsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountReplicaJobsGet(requestParameters, options) {
            return localVarFp.v1AccountReplicaJobsGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get policies in the account
         * @param {ToolkitApiV1AccountRoleGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountRoleGet(requestParameters, options) {
            return localVarFp.v1AccountRoleGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create role in the account
         * @param {ToolkitApiV1AccountRolePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountRolePost(requestParameters, options) {
            return localVarFp.v1AccountRolePost(requestParameters.accountId, requestParameters.human, requestParameters.rolePost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get services in the account
         * @param {ToolkitApiV1AccountServiceGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountServiceGet(requestParameters, options) {
            return localVarFp.v1AccountServiceGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create service in the account
         * @param {ToolkitApiV1AccountServicePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountServicePost(requestParameters, options) {
            return localVarFp.v1AccountServicePost(requestParameters.accountId, requestParameters.human, requestParameters.servicePost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List allowed operations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AllowedOperationGet(options) {
            return localVarFp.v1AllowedOperationGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check permission (action & resource) for a given user or role (defaults to yourself)
         * @param {ToolkitApiV1AllowedPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AllowedPost(requestParameters = {}, options) {
            return localVarFp.v1AllowedPost(requestParameters.allowed, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete app
         * @param {ToolkitApiV1AppDeleteByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AppDeleteById(requestParameters, options) {
            return localVarFp.v1AppDeleteById(requestParameters.appId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get app
         * @param {ToolkitApiV1AppGetByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AppGetById(requestParameters, options) {
            return localVarFp.v1AppGetById(requestParameters.appId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check access to the app
         * @param {ToolkitApiV1AppHeadByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AppHeadById(requestParameters, options) {
            return localVarFp.v1AppHeadById(requestParameters.appId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update app
         * @param {ToolkitApiV1AppPutByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AppPutById(requestParameters, options) {
            return localVarFp.v1AppPutById(requestParameters.appId, requestParameters.human, requestParameters.appPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get accounts in the cluster
         * @param {ToolkitApiV1ClusterAccountGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterAccountGet(requestParameters = {}, options) {
            return localVarFp.v1ClusterAccountGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get apps in the cluster
         * @param {ToolkitApiV1ClusterAppGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterAppGet(requestParameters = {}, options) {
            return localVarFp.v1ClusterAppGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get data in the cluster
         * @param {ToolkitApiV1ClusterDataGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterDataGet(requestParameters = {}, options) {
            return localVarFp.v1ClusterDataGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get jobs in the cluster
         * @param {ToolkitApiV1ClusterJobGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterJobGet(requestParameters = {}, options) {
            return localVarFp.v1ClusterJobGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get job occupation statistics in the cluster
         * @param {ToolkitApiV1ClusterJobOccupancyGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterJobOccupancyGet(requestParameters = {}, options) {
            return localVarFp.v1ClusterJobOccupancyGet(requestParameters.type, requestParameters.from, requestParameters.to, requestParameters.noNull, requestParameters.limit, requestParameters.offset, requestParameters.order, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get runs of jobs in the cluster
         * @param {ToolkitApiV1ClusterJobRunGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterJobRunGet(requestParameters = {}, options) {
            return localVarFp.v1ClusterJobRunGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get private registries in the cluster
         * @param {ToolkitApiV1ClusterPrivateRegistryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterPrivateRegistryGet(requestParameters = {}, options) {
            return localVarFp.v1ClusterPrivateRegistryGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get roles in the cluster
         * @param {ToolkitApiV1ClusterRoleGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterRoleGet(requestParameters = {}, options) {
            return localVarFp.v1ClusterRoleGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get services in the cluster
         * @param {ToolkitApiV1ClusterServiceGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterServiceGet(requestParameters = {}, options) {
            return localVarFp.v1ClusterServiceGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get teams in the cluster
         * @param {ToolkitApiV1ClusterTeamGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterTeamGet(requestParameters = {}, options) {
            return localVarFp.v1ClusterTeamGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get users in the cluster
         * @param {ToolkitApiV1ClusterUserGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterUserGet(requestParameters = {}, options) {
            return localVarFp.v1ClusterUserGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Commit a data and create a version and optionaly a tag
         * @param {ToolkitApiV1DataCommitPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataCommitPost(requestParameters, options) {
            return localVarFp.v1DataCommitPost(requestParameters.dataId, requestParameters.human, requestParameters.tag, requestParameters.version, requestParameters.data, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Download a data
         * @param {ToolkitApiV1DataDownloadGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataDownloadGet(requestParameters, options) {
            return localVarFp.v1DataDownloadGet(requestParameters.dataId, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the data identified by id
         * @param {ToolkitApiV1DataGetByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataGetById(requestParameters, options) {
            return localVarFp.v1DataGetById(requestParameters.dataId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check access to the data
         * @param {ToolkitApiV1DataHeadByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataHeadById(requestParameters, options) {
            return localVarFp.v1DataHeadById(requestParameters.dataId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check if a data is using dataV2
         * @param {ToolkitApiV1DataIsV2GetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataIsV2Get(requestParameters, options) {
            return localVarFp.v1DataIsV2Get(requestParameters.dataId, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check if a data is using dataV2. Return \'true\' or \'false\'
         * @param {ToolkitApiV1DataListGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataListGet(requestParameters, options) {
            return localVarFp.v1DataListGet(requestParameters.dataId, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pull data
         * @param {ToolkitApiV1DataPullGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataPullGet(requestParameters, options) {
            return localVarFp.v1DataPullGet(requestParameters.dataId, requestParameters.version, requestParameters.mapping, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Push data
         * @param {ToolkitApiV1DataPushPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataPushPost(requestParameters, options) {
            return localVarFp.v1DataPushPost(requestParameters.chunk, requestParameters.dataId, requestParameters.version, requestParameters.state, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update data
         * @param {ToolkitApiV1DataPutByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataPutById(requestParameters, options) {
            return localVarFp.v1DataPutById(requestParameters.dataId, requestParameters.human, requestParameters.dataPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Return data tree
         * @param {ToolkitApiV1DataTreeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataTreeGet(requestParameters, options) {
            return localVarFp.v1DataTreeGet(requestParameters.dataId, requestParameters.version, requestParameters.kind, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update data version
         * @param {ToolkitApiV1DataUpdatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataUpdatePost(requestParameters, options) {
            return localVarFp.v1DataUpdatePost(requestParameters.dataId, requestParameters.version, requestParameters.data, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Upload data
         * @param {ToolkitApiV1DataUploadPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DataUploadPost(requestParameters, options) {
            return localVarFp.v1DataUploadPost(requestParameters.chunk, requestParameters.dataId, requestParameters.version, requestParameters.state, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update bid of the job
         * @param {ToolkitApiV1JobBidPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobBidPut(requestParameters, options) {
            return localVarFp.v1JobBidPut(requestParameters.jobId, requestParameters.human, requestParameters.jobRebid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get process agent children of the job
         * @param {ToolkitApiV1JobChildrenGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobChildrenGet(requestParameters, options) {
            return localVarFp.v1JobChildrenGet(requestParameters.jobId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check if job is consented
         * @param {ToolkitApiV1JobConsentHeadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobConsentHead(requestParameters, options) {
            return localVarFp.v1JobConsentHead(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Consent to job scopes
         * @param {ToolkitApiV1JobConsentPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobConsentPost(requestParameters, options) {
            return localVarFp.v1JobConsentPost(requestParameters.jobId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Cancel (a.k.a. kill) a queued, queuing or running job
         * @param {ToolkitApiV1JobDeleteByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobDeleteById(requestParameters, options) {
            return localVarFp.v1JobDeleteById(requestParameters.jobId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Execute a command in a running job
         * @param {ToolkitApiV1JobExecGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobExecGet(requestParameters, options) {
            return localVarFp.v1JobExecGet(requestParameters.jobId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get job information
         * @param {ToolkitApiV1JobGetByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobGetById(requestParameters, options) {
            return localVarFp.v1JobGetById(requestParameters.jobId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check access to the job
         * @param {ToolkitApiV1JobHeadByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobHeadById(requestParameters, options) {
            return localVarFp.v1JobHeadById(requestParameters.jobId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Return logs of a job
         * @param {ToolkitApiV1JobLogsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobLogsGet(requestParameters, options) {
            return localVarFp.v1JobLogsGet(requestParameters.jobId, requestParameters.follow, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Return logs of a job for a given run
         * @param {ToolkitApiV1JobLogsRunGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobLogsRunGet(requestParameters, options) {
            return localVarFp.v1JobLogsRunGet(requestParameters.jobId, requestParameters.runId, requestParameters.follow, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update job info like name, owner, etc
         * @param {ToolkitApiV1JobPutByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobPutById(requestParameters, options) {
            return localVarFp.v1JobPutById(requestParameters.jobId, requestParameters.human, requestParameters.job, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retry an interrupted, failed or cancelled job
         * @param {ToolkitApiV1JobRetryPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobRetryPut(requestParameters, options) {
            return localVarFp.v1JobRetryPut(requestParameters.jobId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check permission (action & resource) for your user or role
         * @param {ToolkitApiV1MeAllowedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeAllowedGet(requestParameters, options) {
            return localVarFp.v1MeAllowedGet(requestParameters.action, requestParameters.resource, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get apps for your user
         * @param {ToolkitApiV1MeAppGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeAppGet(requestParameters = {}, options) {
            return localVarFp.v1MeAppGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get your user/role
         * @param {ToolkitApiV1MeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeGet(requestParameters = {}, options) {
            return localVarFp.v1MeGet(requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get jobs created by your user/role
         * @param {ToolkitApiV1MeJobGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeJobGet(requestParameters = {}, options) {
            return localVarFp.v1MeJobGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get job occupation statistics for your user/role
         * @param {ToolkitApiV1MeJobOccupancyGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeJobOccupancyGet(requestParameters = {}, options) {
            return localVarFp.v1MeJobOccupancyGet(requestParameters.type, requestParameters.from, requestParameters.to, requestParameters.noNull, requestParameters.limit, requestParameters.offset, requestParameters.order, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get runs of jobs created by your user/role
         * @param {ToolkitApiV1MeJobRunGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeJobRunGet(requestParameters = {}, options) {
            return localVarFp.v1MeJobRunGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a policy in your user/role
         * @param {ToolkitApiV1MePolicyDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MePolicyDelete(requestParameters, options) {
            return localVarFp.v1MePolicyDelete(requestParameters.policyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get policies in your user/role
         * @param {ToolkitApiV1MePolicyGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MePolicyGet(requestParameters = {}, options) {
            return localVarFp.v1MePolicyGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post a policy in your user/role
         * @param {ToolkitApiV1MePolicyPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MePolicyPost(requestParameters = {}, options) {
            return localVarFp.v1MePolicyPost(requestParameters.human, requestParameters.policyPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update your user/role
         * @param {ToolkitApiV1MePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MePut(requestParameters = {}, options) {
            return localVarFp.v1MePut(requestParameters.human, requestParameters.userOrRolePost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get terms of the organization of your user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeTermsGet(options) {
            return localVarFp.v1MeTermsGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Set terms as readed for your user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeTermsPut(options) {
            return localVarFp.v1MeTermsPut(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get accounts in the organization
         * @param {ToolkitApiV1OrganizationAccountGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationAccountGet(requestParameters, options) {
            return localVarFp.v1OrganizationAccountGet(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create account in the organization
         * @param {ToolkitApiV1OrganizationAccountPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationAccountPost(requestParameters, options) {
            return localVarFp.v1OrganizationAccountPost(requestParameters.organizationId, requestParameters.human, requestParameters.accountPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get apps in the organization
         * @param {ToolkitApiV1OrganizationAppGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationAppGet(requestParameters, options) {
            return localVarFp.v1OrganizationAppGet(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create app in the organization
         * @param {ToolkitApiV1OrganizationAppPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationAppPost(requestParameters, options) {
            return localVarFp.v1OrganizationAppPost(requestParameters.organizationId, requestParameters.human, requestParameters.appPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get data in the organization
         * @param {ToolkitApiV1OrganizationDataGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationDataGet(requestParameters, options) {
            return localVarFp.v1OrganizationDataGet(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get organizations
         * @param {ToolkitApiV1OrganizationGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationGet(requestParameters = {}, options) {
            return localVarFp.v1OrganizationGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the organization identified by id
         * @param {ToolkitApiV1OrganizationGetByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationGetById(requestParameters, options) {
            return localVarFp.v1OrganizationGetById(requestParameters.organizationId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check access to the organization
         * @param {ToolkitApiV1OrganizationHeadByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationHeadById(requestParameters, options) {
            return localVarFp.v1OrganizationHeadById(requestParameters.organizationId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get jobs in the organization
         * @param {ToolkitApiV1OrganizationJobGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationJobGet(requestParameters, options) {
            return localVarFp.v1OrganizationJobGet(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get job occupation statistics for an organization
         * @param {ToolkitApiV1OrganizationJobOccupancyGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationJobOccupancyGet(requestParameters, options) {
            return localVarFp.v1OrganizationJobOccupancyGet(requestParameters.organizationId, requestParameters.type, requestParameters.from, requestParameters.to, requestParameters.noNull, requestParameters.limit, requestParameters.offset, requestParameters.order, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get runs of jobs in the organization
         * @param {ToolkitApiV1OrganizationJobRunGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationJobRunGet(requestParameters, options) {
            return localVarFp.v1OrganizationJobRunGet(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create organization
         * @param {ToolkitApiV1OrganizationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationPost(requestParameters = {}, options) {
            return localVarFp.v1OrganizationPost(requestParameters.human, requestParameters.organizationPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update organization
         * @param {ToolkitApiV1OrganizationPutByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationPutById(requestParameters, options) {
            return localVarFp.v1OrganizationPutById(requestParameters.organizationId, requestParameters.human, requestParameters.organizationPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all jobs in the organization which are replica jobs
         * @param {ToolkitApiV1OrganizationReplicaJobsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationReplicaJobsGet(requestParameters, options) {
            return localVarFp.v1OrganizationReplicaJobsGet(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get roles in the organization
         * @param {ToolkitApiV1OrganizationRoleGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationRoleGet(requestParameters, options) {
            return localVarFp.v1OrganizationRoleGet(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create role in the organization
         * @param {ToolkitApiV1OrganizationRolePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationRolePost(requestParameters, options) {
            return localVarFp.v1OrganizationRolePost(requestParameters.organizationId, requestParameters.human, requestParameters.rolePost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get services in the organization
         * @param {ToolkitApiV1OrganizationServiceGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationServiceGet(requestParameters, options) {
            return localVarFp.v1OrganizationServiceGet(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get teams in the organization
         * @param {ToolkitApiV1OrganizationTeamGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationTeamGet(requestParameters, options) {
            return localVarFp.v1OrganizationTeamGet(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create team in the organization
         * @param {ToolkitApiV1OrganizationTeamPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationTeamPost(requestParameters, options) {
            return localVarFp.v1OrganizationTeamPost(requestParameters.organizationId, requestParameters.human, requestParameters.teamPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get users in the organization
         * @param {ToolkitApiV1OrganizationUserGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationUserGet(requestParameters, options) {
            return localVarFp.v1OrganizationUserGet(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create user in the organization
         * @param {ToolkitApiV1OrganizationUserPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationUserPost(requestParameters, options) {
            return localVarFp.v1OrganizationUserPost(requestParameters.organizationId, requestParameters.human, requestParameters.userPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the private registry identified by id
         * @param {ToolkitApiV1PrivateRegistryGetByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PrivateRegistryGetById(requestParameters, options) {
            return localVarFp.v1PrivateRegistryGetById(requestParameters.privateregistryId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check access to the privateregistry
         * @param {ToolkitApiV1PrivateRegistryHeadByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PrivateRegistryHeadById(requestParameters, options) {
            return localVarFp.v1PrivateRegistryHeadById(requestParameters.privateregistryId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update private registry
         * @param {ToolkitApiV1PrivateRegistryPutByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PrivateRegistryPutById(requestParameters, options) {
            return localVarFp.v1PrivateRegistryPutById(requestParameters.privateregistryId, requestParameters.human, requestParameters.privateregistryPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Cancel ReplicaJobs via replicaGroupId
         * @param {ToolkitApiV1ReplicaJobsDeleteByReplicaGroupIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ReplicaJobsDeleteByReplicaGroupId(requestParameters, options) {
            return localVarFp.v1ReplicaJobsDeleteByReplicaGroupId(requestParameters.replicaGroupId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get ReplicaJobs via replicaGroupId
         * @param {ToolkitApiV1ReplicaJobsGetByReplicaGroupIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ReplicaJobsGetByReplicaGroupId(requestParameters, options) {
            return localVarFp.v1ReplicaJobsGetByReplicaGroupId(requestParameters.replicaGroupId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check access to the ReplicaJobs via replicaGroupId
         * @param {ToolkitApiV1ReplicaJobsHeadByReplicaGroupIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ReplicaJobsHeadByReplicaGroupId(requestParameters, options) {
            return localVarFp.v1ReplicaJobsHeadByReplicaGroupId(requestParameters.replicaGroupId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check permission (action & resource) for a given user or role
         * @param {ToolkitApiV1ResourceAllowedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ResourceAllowedGet(requestParameters, options) {
            return localVarFp.v1ResourceAllowedGet(requestParameters.resourceId, requestParameters.action, requestParameters.resource, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get resource
         * @param {ToolkitApiV1ResourceGetByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ResourceGetById(requestParameters, options) {
            return localVarFp.v1ResourceGetById(requestParameters.resourceId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check access to the resource
         * @param {ToolkitApiV1ResourceHeadByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ResourceHeadById(requestParameters, options) {
            return localVarFp.v1ResourceHeadById(requestParameters.resourceId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Resolve a resource id
         * @param {ToolkitApiV1ResourceIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ResourceIdGet(requestParameters, options) {
            return localVarFp.v1ResourceIdGet(requestParameters.resourceId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get roles in the resource
         * @param {ToolkitApiV1ResourceRoleGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ResourceRoleGet(requestParameters, options) {
            return localVarFp.v1ResourceRoleGet(requestParameters.resourceId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create role in the resource
         * @param {ToolkitApiV1ResourceRolePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ResourceRolePost(requestParameters, options) {
            return localVarFp.v1ResourceRolePost(requestParameters.resourceId, requestParameters.human, requestParameters.rolePost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check permission (action & resource) for a given role
         * @param {ToolkitApiV1RoleAllowedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleAllowedGet(requestParameters, options) {
            return localVarFp.v1RoleAllowedGet(requestParameters.action, requestParameters.resource, requestParameters.roleId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the role identified by id
         * @param {ToolkitApiV1RoleGetByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleGetById(requestParameters, options) {
            return localVarFp.v1RoleGetById(requestParameters.roleId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check access to the role
         * @param {ToolkitApiV1RoleHeadByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleHeadById(requestParameters, options) {
            return localVarFp.v1RoleHeadById(requestParameters.roleId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get jobs created by the role
         * @param {ToolkitApiV1RoleJobGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleJobGet(requestParameters, options) {
            return localVarFp.v1RoleJobGet(requestParameters.roleId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get runs of jobs created by the role
         * @param {ToolkitApiV1RoleJobRunGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleJobRunGet(requestParameters, options) {
            return localVarFp.v1RoleJobRunGet(requestParameters.roleId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a key in the role
         * @param {ToolkitApiV1RoleKeyDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleKeyDelete(requestParameters, options) {
            return localVarFp.v1RoleKeyDelete(requestParameters.roleId, requestParameters.accessKey, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get keys in the role
         * @param {ToolkitApiV1RoleKeyGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleKeyGet(requestParameters, options) {
            return localVarFp.v1RoleKeyGet(requestParameters.roleId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a key in the role
         * @param {ToolkitApiV1RoleKeyPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleKeyPost(requestParameters, options) {
            return localVarFp.v1RoleKeyPost(requestParameters.roleId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.roleKey, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a member in the role
         * @param {ToolkitApiV1RoleMemberDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleMemberDelete(requestParameters, options) {
            return localVarFp.v1RoleMemberDelete(requestParameters.roleId, requestParameters.memberId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get members in the role
         * @param {ToolkitApiV1RoleMemberGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleMemberGet(requestParameters, options) {
            return localVarFp.v1RoleMemberGet(requestParameters.roleId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.type, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post a member in the role
         * @param {ToolkitApiV1RoleMemberPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleMemberPost(requestParameters, options) {
            return localVarFp.v1RoleMemberPost(requestParameters.roleId, requestParameters.memberId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a policy in the role
         * @param {ToolkitApiV1RolePolicyDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RolePolicyDelete(requestParameters, options) {
            return localVarFp.v1RolePolicyDelete(requestParameters.roleId, requestParameters.policyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get policies in the role
         * @param {ToolkitApiV1RolePolicyGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RolePolicyGet(requestParameters, options) {
            return localVarFp.v1RolePolicyGet(requestParameters.roleId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.includeInactive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post a policy in the role
         * @param {ToolkitApiV1RolePolicyPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RolePolicyPost(requestParameters, options) {
            return localVarFp.v1RolePolicyPost(requestParameters.roleId, requestParameters.human, requestParameters.policyPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update role
         * @param {ToolkitApiV1RolePutByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RolePutById(requestParameters, options) {
            return localVarFp.v1RolePutById(requestParameters.roleId, requestParameters.human, requestParameters.rolePost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the service identified by id
         * @param {ToolkitApiV1ServiceGetByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ServiceGetById(requestParameters, options) {
            return localVarFp.v1ServiceGetById(requestParameters.serviceId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check access to the service
         * @param {ToolkitApiV1ServiceHeadByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ServiceHeadById(requestParameters, options) {
            return localVarFp.v1ServiceHeadById(requestParameters.serviceId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get jobs created by the service
         * @param {ToolkitApiV1ServiceJobGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ServiceJobGet(requestParameters, options) {
            return localVarFp.v1ServiceJobGet(requestParameters.serviceId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get runs of jobs created by the service
         * @param {ToolkitApiV1ServiceJobRunGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ServiceJobRunGet(requestParameters, options) {
            return localVarFp.v1ServiceJobRunGet(requestParameters.serviceId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update service
         * @param {ToolkitApiV1ServicePutByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ServicePutById(requestParameters, options) {
            return localVarFp.v1ServicePutById(requestParameters.serviceId, requestParameters.human, requestParameters.servicePost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create account in your account
         * @param {ToolkitApiV1ShorcutAccountPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShorcutAccountPost(requestParameters = {}, options) {
            return localVarFp.v1ShorcutAccountPost(requestParameters.human, requestParameters.accountPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create app in your organization
         * @param {ToolkitApiV1ShorcutAppPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShorcutAppPost(requestParameters = {}, options) {
            return localVarFp.v1ShorcutAppPost(requestParameters.human, requestParameters.appPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create data on your account
         * @param {ToolkitApiV1ShorcutDataPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShorcutDataPost(requestParameters = {}, options) {
            return localVarFp.v1ShorcutDataPost(requestParameters.human, requestParameters.dataPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create job on your account
         * @param {ToolkitApiV1ShorcutJobPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShorcutJobPost(requestParameters = {}, options) {
            return localVarFp.v1ShorcutJobPost(requestParameters.human, requestParameters.jobSpec, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get runs of jobs in your account
         * @param {ToolkitApiV1ShorcutJobRunGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShorcutJobRunGet(requestParameters = {}, options) {
            return localVarFp.v1ShorcutJobRunGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get accounts in your organization
         * @param {ToolkitApiV1ShortcutAccountGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutAccountGet(requestParameters = {}, options) {
            return localVarFp.v1ShortcutAccountGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get apps in your organization
         * @param {ToolkitApiV1ShortcutAppGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutAppGet(requestParameters = {}, options) {
            return localVarFp.v1ShortcutAppGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get data on your account
         * @param {ToolkitApiV1ShortcutDataGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutDataGet(requestParameters = {}, options) {
            return localVarFp.v1ShortcutDataGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get jobs in your account
         * @param {ToolkitApiV1ShortcutJobGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutJobGet(requestParameters = {}, options) {
            return localVarFp.v1ShortcutJobGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get private registries in your account
         * @param {ToolkitApiV1ShortcutPrivateRegistryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutPrivateRegistryGet(requestParameters = {}, options) {
            return localVarFp.v1ShortcutPrivateRegistryGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create private registry in your account
         * @param {ToolkitApiV1ShortcutPrivateRegistryPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutPrivateRegistryPost(requestParameters = {}, options) {
            return localVarFp.v1ShortcutPrivateRegistryPost(requestParameters.human, requestParameters.privateregistryPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get jobs in your account which are replica jobs
         * @param {ToolkitApiV1ShortcutReplicasJobsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutReplicasJobsGet(requestParameters = {}, options) {
            return localVarFp.v1ShortcutReplicasJobsGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get services in your account
         * @param {ToolkitApiV1ShortcutServiceGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutServiceGet(requestParameters = {}, options) {
            return localVarFp.v1ShortcutServiceGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create service in your account
         * @param {ToolkitApiV1ShortcutServicePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutServicePost(requestParameters = {}, options) {
            return localVarFp.v1ShortcutServicePost(requestParameters.human, requestParameters.servicePost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get teams in your organization
         * @param {ToolkitApiV1ShortcutTeamGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutTeamGet(requestParameters = {}, options) {
            return localVarFp.v1ShortcutTeamGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create team in your organization
         * @param {ToolkitApiV1ShortcutTeamPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutTeamPost(requestParameters = {}, options) {
            return localVarFp.v1ShortcutTeamPost(requestParameters.human, requestParameters.team, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get users in your organization
         * @param {ToolkitApiV1ShortcutUserGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutUserGet(requestParameters = {}, options) {
            return localVarFp.v1ShortcutUserGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create user in your organization
         * @param {ToolkitApiV1ShortcutUserPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutUserPost(requestParameters = {}, options) {
            return localVarFp.v1ShortcutUserPost(requestParameters.human, requestParameters.userPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get swagger.json
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1SwaggerGetJson(options) {
            return localVarFp.v1SwaggerGetJson(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the team identified by id
         * @param {ToolkitApiV1TeamGetByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamGetById(requestParameters, options) {
            return localVarFp.v1TeamGetById(requestParameters.teamId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check access to the team
         * @param {ToolkitApiV1TeamHeadByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamHeadById(requestParameters, options) {
            return localVarFp.v1TeamHeadById(requestParameters.teamId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a member in the team
         * @param {ToolkitApiV1TeamMemberDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamMemberDelete(requestParameters, options) {
            return localVarFp.v1TeamMemberDelete(requestParameters.teamId, requestParameters.memberId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get members in the team
         * @param {ToolkitApiV1TeamMemberGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamMemberGet(requestParameters, options) {
            return localVarFp.v1TeamMemberGet(requestParameters.teamId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.type, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post a member in the team
         * @param {ToolkitApiV1TeamMemberPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamMemberPost(requestParameters, options) {
            return localVarFp.v1TeamMemberPost(requestParameters.teamId, requestParameters.memberId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a policy in the team
         * @param {ToolkitApiV1TeamPolicyDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamPolicyDelete(requestParameters, options) {
            return localVarFp.v1TeamPolicyDelete(requestParameters.teamId, requestParameters.policyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get policies in the team
         * @param {ToolkitApiV1TeamPolicyGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamPolicyGet(requestParameters, options) {
            return localVarFp.v1TeamPolicyGet(requestParameters.teamId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.includeInactive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post a policy in the team
         * @param {ToolkitApiV1TeamPolicyPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamPolicyPost(requestParameters, options) {
            return localVarFp.v1TeamPolicyPost(requestParameters.teamId, requestParameters.human, requestParameters.policyPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update team
         * @param {ToolkitApiV1TeamPutByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamPutById(requestParameters, options) {
            return localVarFp.v1TeamPutById(requestParameters.teamId, requestParameters.human, requestParameters.teamPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get roles in the team
         * @param {ToolkitApiV1TeamRoleGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamRoleGet(requestParameters, options) {
            return localVarFp.v1TeamRoleGet(requestParameters.teamId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post a role in the team
         * @param {ToolkitApiV1TeamRolePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TeamRolePost(requestParameters, options) {
            return localVarFp.v1TeamRolePost(requestParameters.teamId, requestParameters.human, requestParameters.rolePost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check permission (action & resource) for a given user
         * @param {ToolkitApiV1UserAllowedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserAllowedGet(requestParameters, options) {
            return localVarFp.v1UserAllowedGet(requestParameters.action, requestParameters.resource, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get apps for the user
         * @param {ToolkitApiV1UserAppGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserAppGet(requestParameters, options) {
            return localVarFp.v1UserAppGet(requestParameters.userId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the user identified by id
         * @param {ToolkitApiV1UserGetByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserGetById(requestParameters, options) {
            return localVarFp.v1UserGetById(requestParameters.userId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check access to the user
         * @param {ToolkitApiV1UserHeadByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserHeadById(requestParameters, options) {
            return localVarFp.v1UserHeadById(requestParameters.userId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get jobs created by the user
         * @param {ToolkitApiV1UserJobGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserJobGet(requestParameters, options) {
            return localVarFp.v1UserJobGet(requestParameters.userId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get job occupation statistics for a user
         * @param {ToolkitApiV1UserJobOccupancyGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserJobOccupancyGet(requestParameters, options) {
            return localVarFp.v1UserJobOccupancyGet(requestParameters.userId, requestParameters.type, requestParameters.from, requestParameters.to, requestParameters.noNull, requestParameters.limit, requestParameters.offset, requestParameters.order, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get runs of jobs created by the user
         * @param {ToolkitApiV1UserJobRunGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserJobRunGet(requestParameters, options) {
            return localVarFp.v1UserJobRunGet(requestParameters.userId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a policy in the user
         * @param {ToolkitApiV1UserPolicyDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserPolicyDelete(requestParameters, options) {
            return localVarFp.v1UserPolicyDelete(requestParameters.userId, requestParameters.policyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get policies in the user
         * @param {ToolkitApiV1UserPolicyGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserPolicyGet(requestParameters, options) {
            return localVarFp.v1UserPolicyGet(requestParameters.userId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, requestParameters.includeInactive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Post a policy in the user
         * @param {ToolkitApiV1UserPolicyPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserPolicyPost(requestParameters, options) {
            return localVarFp.v1UserPolicyPost(requestParameters.userId, requestParameters.human, requestParameters.policyPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update user
         * @param {ToolkitApiV1UserPutByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserPutById(requestParameters, options) {
            return localVarFp.v1UserPutById(requestParameters.userId, requestParameters.human, requestParameters.userPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all jobs created by the user which are replica jobs
         * @param {ToolkitApiV1UserReplicaJobsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserReplicaJobsGet(requestParameters, options) {
            return localVarFp.v1UserReplicaJobsGet(requestParameters.userId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get terms of the organization of the user
         * @param {ToolkitApiV1UserTermsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserTermsGet(requestParameters, options) {
            return localVarFp.v1UserTermsGet(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Set terms as readed for the user
         * @param {ToolkitApiV1UserTermsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserTermsPut(requestParameters, options) {
            return localVarFp.v1UserTermsPut(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the users and roles that have permission to perform the given action(s) on the given resource(s)
         * @param {ToolkitApiV1WhoIsAllowedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1WhoIsAllowedGet(requestParameters, options) {
            return localVarFp.v1WhoIsAllowedGet(requestParameters.resource, requestParameters.action, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ToolkitApiFactory = ToolkitApiFactory;
/**
 * ToolkitApi - object-oriented interface
 * @export
 * @class ToolkitApi
 * @extends {BaseAPI}
 */
class ToolkitApi extends base_1.BaseAPI {
    /**
     *
     * @summary Get apps in the account
     * @param {ToolkitApiV1AccountAppGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1AccountAppGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1AccountAppGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create app in the account
     * @param {ToolkitApiV1AccountAppPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1AccountAppPost(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1AccountAppPost(requestParameters.accountId, requestParameters.human, requestParameters.appPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get data in the account
     * @param {ToolkitApiV1AccountDataGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1AccountDataGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1AccountDataGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create data in the account
     * @param {ToolkitApiV1AccountDataPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1AccountDataPost(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1AccountDataPost(requestParameters.accountId, requestParameters.human, requestParameters.dataPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get accounts in the account
     * @param {ToolkitApiV1AccountGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1AccountGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1AccountGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get account
     * @param {ToolkitApiV1AccountGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1AccountGetById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1AccountGetById(requestParameters.accountId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Check access to the account
     * @param {ToolkitApiV1AccountHeadByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1AccountHeadById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1AccountHeadById(requestParameters.accountId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get jobs in the account
     * @param {ToolkitApiV1AccountJobGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1AccountJobGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1AccountJobGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get job occupation statistics for an account
     * @param {ToolkitApiV1AccountJobOccupancyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1AccountJobOccupancyGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1AccountJobOccupancyGet(requestParameters.accountId, requestParameters.type, requestParameters.from, requestParameters.to, requestParameters.noNull, requestParameters.limit, requestParameters.offset, requestParameters.order, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create job in the account
     * @param {ToolkitApiV1AccountJobPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1AccountJobPost(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1AccountJobPost(requestParameters.accountId, requestParameters.human, requestParameters.jobSpec, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get runs of jobs in the account
     * @param {ToolkitApiV1AccountJobRunGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1AccountJobRunGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1AccountJobRunGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create account in the account
     * @param {ToolkitApiV1AccountPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1AccountPost(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1AccountPost(requestParameters.accountId, requestParameters.human, requestParameters.accountPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update account
     * @param {ToolkitApiV1AccountPutByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1AccountPutById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1AccountPutById(requestParameters.accountId, requestParameters.human, requestParameters.accountPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all jobs in the account which are replica jobs
     * @param {ToolkitApiV1AccountReplicaJobsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1AccountReplicaJobsGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1AccountReplicaJobsGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get policies in the account
     * @param {ToolkitApiV1AccountRoleGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1AccountRoleGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1AccountRoleGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create role in the account
     * @param {ToolkitApiV1AccountRolePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1AccountRolePost(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1AccountRolePost(requestParameters.accountId, requestParameters.human, requestParameters.rolePost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get services in the account
     * @param {ToolkitApiV1AccountServiceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1AccountServiceGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1AccountServiceGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create service in the account
     * @param {ToolkitApiV1AccountServicePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1AccountServicePost(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1AccountServicePost(requestParameters.accountId, requestParameters.human, requestParameters.servicePost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List allowed operations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1AllowedOperationGet(options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1AllowedOperationGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Check permission (action & resource) for a given user or role (defaults to yourself)
     * @param {ToolkitApiV1AllowedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1AllowedPost(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1AllowedPost(requestParameters.allowed, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete app
     * @param {ToolkitApiV1AppDeleteByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1AppDeleteById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1AppDeleteById(requestParameters.appId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get app
     * @param {ToolkitApiV1AppGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1AppGetById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1AppGetById(requestParameters.appId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Check access to the app
     * @param {ToolkitApiV1AppHeadByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1AppHeadById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1AppHeadById(requestParameters.appId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update app
     * @param {ToolkitApiV1AppPutByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1AppPutById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1AppPutById(requestParameters.appId, requestParameters.human, requestParameters.appPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get accounts in the cluster
     * @param {ToolkitApiV1ClusterAccountGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ClusterAccountGet(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ClusterAccountGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get apps in the cluster
     * @param {ToolkitApiV1ClusterAppGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ClusterAppGet(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ClusterAppGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get data in the cluster
     * @param {ToolkitApiV1ClusterDataGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ClusterDataGet(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ClusterDataGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get jobs in the cluster
     * @param {ToolkitApiV1ClusterJobGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ClusterJobGet(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ClusterJobGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get job occupation statistics in the cluster
     * @param {ToolkitApiV1ClusterJobOccupancyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ClusterJobOccupancyGet(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ClusterJobOccupancyGet(requestParameters.type, requestParameters.from, requestParameters.to, requestParameters.noNull, requestParameters.limit, requestParameters.offset, requestParameters.order, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get runs of jobs in the cluster
     * @param {ToolkitApiV1ClusterJobRunGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ClusterJobRunGet(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ClusterJobRunGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get private registries in the cluster
     * @param {ToolkitApiV1ClusterPrivateRegistryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ClusterPrivateRegistryGet(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ClusterPrivateRegistryGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get roles in the cluster
     * @param {ToolkitApiV1ClusterRoleGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ClusterRoleGet(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ClusterRoleGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get services in the cluster
     * @param {ToolkitApiV1ClusterServiceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ClusterServiceGet(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ClusterServiceGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get teams in the cluster
     * @param {ToolkitApiV1ClusterTeamGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ClusterTeamGet(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ClusterTeamGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get users in the cluster
     * @param {ToolkitApiV1ClusterUserGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ClusterUserGet(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ClusterUserGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Commit a data and create a version and optionaly a tag
     * @param {ToolkitApiV1DataCommitPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1DataCommitPost(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1DataCommitPost(requestParameters.dataId, requestParameters.human, requestParameters.tag, requestParameters.version, requestParameters.data, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Download a data
     * @param {ToolkitApiV1DataDownloadGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1DataDownloadGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1DataDownloadGet(requestParameters.dataId, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the data identified by id
     * @param {ToolkitApiV1DataGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1DataGetById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1DataGetById(requestParameters.dataId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Check access to the data
     * @param {ToolkitApiV1DataHeadByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1DataHeadById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1DataHeadById(requestParameters.dataId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Check if a data is using dataV2
     * @param {ToolkitApiV1DataIsV2GetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1DataIsV2Get(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1DataIsV2Get(requestParameters.dataId, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Check if a data is using dataV2. Return \'true\' or \'false\'
     * @param {ToolkitApiV1DataListGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1DataListGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1DataListGet(requestParameters.dataId, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Pull data
     * @param {ToolkitApiV1DataPullGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1DataPullGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1DataPullGet(requestParameters.dataId, requestParameters.version, requestParameters.mapping, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Push data
     * @param {ToolkitApiV1DataPushPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1DataPushPost(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1DataPushPost(requestParameters.chunk, requestParameters.dataId, requestParameters.version, requestParameters.state, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update data
     * @param {ToolkitApiV1DataPutByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1DataPutById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1DataPutById(requestParameters.dataId, requestParameters.human, requestParameters.dataPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Return data tree
     * @param {ToolkitApiV1DataTreeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1DataTreeGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1DataTreeGet(requestParameters.dataId, requestParameters.version, requestParameters.kind, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update data version
     * @param {ToolkitApiV1DataUpdatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1DataUpdatePost(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1DataUpdatePost(requestParameters.dataId, requestParameters.version, requestParameters.data, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Upload data
     * @param {ToolkitApiV1DataUploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1DataUploadPost(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1DataUploadPost(requestParameters.chunk, requestParameters.dataId, requestParameters.version, requestParameters.state, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update bid of the job
     * @param {ToolkitApiV1JobBidPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1JobBidPut(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1JobBidPut(requestParameters.jobId, requestParameters.human, requestParameters.jobRebid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get process agent children of the job
     * @param {ToolkitApiV1JobChildrenGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1JobChildrenGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1JobChildrenGet(requestParameters.jobId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Check if job is consented
     * @param {ToolkitApiV1JobConsentHeadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1JobConsentHead(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1JobConsentHead(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Consent to job scopes
     * @param {ToolkitApiV1JobConsentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1JobConsentPost(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1JobConsentPost(requestParameters.jobId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Cancel (a.k.a. kill) a queued, queuing or running job
     * @param {ToolkitApiV1JobDeleteByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1JobDeleteById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1JobDeleteById(requestParameters.jobId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Execute a command in a running job
     * @param {ToolkitApiV1JobExecGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1JobExecGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1JobExecGet(requestParameters.jobId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get job information
     * @param {ToolkitApiV1JobGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1JobGetById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1JobGetById(requestParameters.jobId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Check access to the job
     * @param {ToolkitApiV1JobHeadByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1JobHeadById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1JobHeadById(requestParameters.jobId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Return logs of a job
     * @param {ToolkitApiV1JobLogsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1JobLogsGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1JobLogsGet(requestParameters.jobId, requestParameters.follow, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Return logs of a job for a given run
     * @param {ToolkitApiV1JobLogsRunGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1JobLogsRunGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1JobLogsRunGet(requestParameters.jobId, requestParameters.runId, requestParameters.follow, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update job info like name, owner, etc
     * @param {ToolkitApiV1JobPutByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1JobPutById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1JobPutById(requestParameters.jobId, requestParameters.human, requestParameters.job, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retry an interrupted, failed or cancelled job
     * @param {ToolkitApiV1JobRetryPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1JobRetryPut(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1JobRetryPut(requestParameters.jobId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Check permission (action & resource) for your user or role
     * @param {ToolkitApiV1MeAllowedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1MeAllowedGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1MeAllowedGet(requestParameters.action, requestParameters.resource, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get apps for your user
     * @param {ToolkitApiV1MeAppGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1MeAppGet(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1MeAppGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get your user/role
     * @param {ToolkitApiV1MeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1MeGet(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1MeGet(requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get jobs created by your user/role
     * @param {ToolkitApiV1MeJobGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1MeJobGet(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1MeJobGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get job occupation statistics for your user/role
     * @param {ToolkitApiV1MeJobOccupancyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1MeJobOccupancyGet(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1MeJobOccupancyGet(requestParameters.type, requestParameters.from, requestParameters.to, requestParameters.noNull, requestParameters.limit, requestParameters.offset, requestParameters.order, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get runs of jobs created by your user/role
     * @param {ToolkitApiV1MeJobRunGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1MeJobRunGet(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1MeJobRunGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a policy in your user/role
     * @param {ToolkitApiV1MePolicyDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1MePolicyDelete(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1MePolicyDelete(requestParameters.policyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get policies in your user/role
     * @param {ToolkitApiV1MePolicyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1MePolicyGet(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1MePolicyGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post a policy in your user/role
     * @param {ToolkitApiV1MePolicyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1MePolicyPost(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1MePolicyPost(requestParameters.human, requestParameters.policyPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update your user/role
     * @param {ToolkitApiV1MePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1MePut(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1MePut(requestParameters.human, requestParameters.userOrRolePost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get terms of the organization of your user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1MeTermsGet(options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1MeTermsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Set terms as readed for your user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1MeTermsPut(options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1MeTermsPut(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get accounts in the organization
     * @param {ToolkitApiV1OrganizationAccountGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1OrganizationAccountGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1OrganizationAccountGet(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create account in the organization
     * @param {ToolkitApiV1OrganizationAccountPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1OrganizationAccountPost(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1OrganizationAccountPost(requestParameters.organizationId, requestParameters.human, requestParameters.accountPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get apps in the organization
     * @param {ToolkitApiV1OrganizationAppGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1OrganizationAppGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1OrganizationAppGet(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create app in the organization
     * @param {ToolkitApiV1OrganizationAppPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1OrganizationAppPost(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1OrganizationAppPost(requestParameters.organizationId, requestParameters.human, requestParameters.appPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get data in the organization
     * @param {ToolkitApiV1OrganizationDataGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1OrganizationDataGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1OrganizationDataGet(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get organizations
     * @param {ToolkitApiV1OrganizationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1OrganizationGet(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1OrganizationGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the organization identified by id
     * @param {ToolkitApiV1OrganizationGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1OrganizationGetById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1OrganizationGetById(requestParameters.organizationId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Check access to the organization
     * @param {ToolkitApiV1OrganizationHeadByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1OrganizationHeadById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1OrganizationHeadById(requestParameters.organizationId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get jobs in the organization
     * @param {ToolkitApiV1OrganizationJobGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1OrganizationJobGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1OrganizationJobGet(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get job occupation statistics for an organization
     * @param {ToolkitApiV1OrganizationJobOccupancyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1OrganizationJobOccupancyGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1OrganizationJobOccupancyGet(requestParameters.organizationId, requestParameters.type, requestParameters.from, requestParameters.to, requestParameters.noNull, requestParameters.limit, requestParameters.offset, requestParameters.order, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get runs of jobs in the organization
     * @param {ToolkitApiV1OrganizationJobRunGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1OrganizationJobRunGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1OrganizationJobRunGet(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create organization
     * @param {ToolkitApiV1OrganizationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1OrganizationPost(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1OrganizationPost(requestParameters.human, requestParameters.organizationPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update organization
     * @param {ToolkitApiV1OrganizationPutByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1OrganizationPutById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1OrganizationPutById(requestParameters.organizationId, requestParameters.human, requestParameters.organizationPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all jobs in the organization which are replica jobs
     * @param {ToolkitApiV1OrganizationReplicaJobsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1OrganizationReplicaJobsGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1OrganizationReplicaJobsGet(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get roles in the organization
     * @param {ToolkitApiV1OrganizationRoleGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1OrganizationRoleGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1OrganizationRoleGet(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create role in the organization
     * @param {ToolkitApiV1OrganizationRolePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1OrganizationRolePost(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1OrganizationRolePost(requestParameters.organizationId, requestParameters.human, requestParameters.rolePost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get services in the organization
     * @param {ToolkitApiV1OrganizationServiceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1OrganizationServiceGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1OrganizationServiceGet(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get teams in the organization
     * @param {ToolkitApiV1OrganizationTeamGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1OrganizationTeamGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1OrganizationTeamGet(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create team in the organization
     * @param {ToolkitApiV1OrganizationTeamPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1OrganizationTeamPost(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1OrganizationTeamPost(requestParameters.organizationId, requestParameters.human, requestParameters.teamPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get users in the organization
     * @param {ToolkitApiV1OrganizationUserGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1OrganizationUserGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1OrganizationUserGet(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create user in the organization
     * @param {ToolkitApiV1OrganizationUserPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1OrganizationUserPost(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1OrganizationUserPost(requestParameters.organizationId, requestParameters.human, requestParameters.userPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the private registry identified by id
     * @param {ToolkitApiV1PrivateRegistryGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1PrivateRegistryGetById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1PrivateRegistryGetById(requestParameters.privateregistryId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Check access to the privateregistry
     * @param {ToolkitApiV1PrivateRegistryHeadByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1PrivateRegistryHeadById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1PrivateRegistryHeadById(requestParameters.privateregistryId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update private registry
     * @param {ToolkitApiV1PrivateRegistryPutByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1PrivateRegistryPutById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1PrivateRegistryPutById(requestParameters.privateregistryId, requestParameters.human, requestParameters.privateregistryPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Cancel ReplicaJobs via replicaGroupId
     * @param {ToolkitApiV1ReplicaJobsDeleteByReplicaGroupIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ReplicaJobsDeleteByReplicaGroupId(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ReplicaJobsDeleteByReplicaGroupId(requestParameters.replicaGroupId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get ReplicaJobs via replicaGroupId
     * @param {ToolkitApiV1ReplicaJobsGetByReplicaGroupIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ReplicaJobsGetByReplicaGroupId(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ReplicaJobsGetByReplicaGroupId(requestParameters.replicaGroupId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Check access to the ReplicaJobs via replicaGroupId
     * @param {ToolkitApiV1ReplicaJobsHeadByReplicaGroupIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ReplicaJobsHeadByReplicaGroupId(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ReplicaJobsHeadByReplicaGroupId(requestParameters.replicaGroupId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Check permission (action & resource) for a given user or role
     * @param {ToolkitApiV1ResourceAllowedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ResourceAllowedGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ResourceAllowedGet(requestParameters.resourceId, requestParameters.action, requestParameters.resource, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get resource
     * @param {ToolkitApiV1ResourceGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ResourceGetById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ResourceGetById(requestParameters.resourceId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Check access to the resource
     * @param {ToolkitApiV1ResourceHeadByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ResourceHeadById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ResourceHeadById(requestParameters.resourceId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Resolve a resource id
     * @param {ToolkitApiV1ResourceIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ResourceIdGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ResourceIdGet(requestParameters.resourceId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get roles in the resource
     * @param {ToolkitApiV1ResourceRoleGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ResourceRoleGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ResourceRoleGet(requestParameters.resourceId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create role in the resource
     * @param {ToolkitApiV1ResourceRolePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ResourceRolePost(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ResourceRolePost(requestParameters.resourceId, requestParameters.human, requestParameters.rolePost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Check permission (action & resource) for a given role
     * @param {ToolkitApiV1RoleAllowedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1RoleAllowedGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1RoleAllowedGet(requestParameters.action, requestParameters.resource, requestParameters.roleId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the role identified by id
     * @param {ToolkitApiV1RoleGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1RoleGetById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1RoleGetById(requestParameters.roleId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Check access to the role
     * @param {ToolkitApiV1RoleHeadByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1RoleHeadById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1RoleHeadById(requestParameters.roleId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get jobs created by the role
     * @param {ToolkitApiV1RoleJobGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1RoleJobGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1RoleJobGet(requestParameters.roleId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get runs of jobs created by the role
     * @param {ToolkitApiV1RoleJobRunGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1RoleJobRunGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1RoleJobRunGet(requestParameters.roleId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a key in the role
     * @param {ToolkitApiV1RoleKeyDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1RoleKeyDelete(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1RoleKeyDelete(requestParameters.roleId, requestParameters.accessKey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get keys in the role
     * @param {ToolkitApiV1RoleKeyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1RoleKeyGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1RoleKeyGet(requestParameters.roleId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a key in the role
     * @param {ToolkitApiV1RoleKeyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1RoleKeyPost(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1RoleKeyPost(requestParameters.roleId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.roleKey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a member in the role
     * @param {ToolkitApiV1RoleMemberDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1RoleMemberDelete(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1RoleMemberDelete(requestParameters.roleId, requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get members in the role
     * @param {ToolkitApiV1RoleMemberGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1RoleMemberGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1RoleMemberGet(requestParameters.roleId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post a member in the role
     * @param {ToolkitApiV1RoleMemberPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1RoleMemberPost(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1RoleMemberPost(requestParameters.roleId, requestParameters.memberId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a policy in the role
     * @param {ToolkitApiV1RolePolicyDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1RolePolicyDelete(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1RolePolicyDelete(requestParameters.roleId, requestParameters.policyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get policies in the role
     * @param {ToolkitApiV1RolePolicyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1RolePolicyGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1RolePolicyGet(requestParameters.roleId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.includeInactive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post a policy in the role
     * @param {ToolkitApiV1RolePolicyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1RolePolicyPost(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1RolePolicyPost(requestParameters.roleId, requestParameters.human, requestParameters.policyPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update role
     * @param {ToolkitApiV1RolePutByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1RolePutById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1RolePutById(requestParameters.roleId, requestParameters.human, requestParameters.rolePost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the service identified by id
     * @param {ToolkitApiV1ServiceGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ServiceGetById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ServiceGetById(requestParameters.serviceId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Check access to the service
     * @param {ToolkitApiV1ServiceHeadByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ServiceHeadById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ServiceHeadById(requestParameters.serviceId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get jobs created by the service
     * @param {ToolkitApiV1ServiceJobGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ServiceJobGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ServiceJobGet(requestParameters.serviceId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get runs of jobs created by the service
     * @param {ToolkitApiV1ServiceJobRunGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ServiceJobRunGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ServiceJobRunGet(requestParameters.serviceId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update service
     * @param {ToolkitApiV1ServicePutByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ServicePutById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ServicePutById(requestParameters.serviceId, requestParameters.human, requestParameters.servicePost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create account in your account
     * @param {ToolkitApiV1ShorcutAccountPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ShorcutAccountPost(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ShorcutAccountPost(requestParameters.human, requestParameters.accountPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create app in your organization
     * @param {ToolkitApiV1ShorcutAppPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ShorcutAppPost(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ShorcutAppPost(requestParameters.human, requestParameters.appPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create data on your account
     * @param {ToolkitApiV1ShorcutDataPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ShorcutDataPost(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ShorcutDataPost(requestParameters.human, requestParameters.dataPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create job on your account
     * @param {ToolkitApiV1ShorcutJobPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ShorcutJobPost(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ShorcutJobPost(requestParameters.human, requestParameters.jobSpec, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get runs of jobs in your account
     * @param {ToolkitApiV1ShorcutJobRunGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ShorcutJobRunGet(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ShorcutJobRunGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get accounts in your organization
     * @param {ToolkitApiV1ShortcutAccountGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ShortcutAccountGet(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ShortcutAccountGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get apps in your organization
     * @param {ToolkitApiV1ShortcutAppGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ShortcutAppGet(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ShortcutAppGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get data on your account
     * @param {ToolkitApiV1ShortcutDataGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ShortcutDataGet(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ShortcutDataGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get jobs in your account
     * @param {ToolkitApiV1ShortcutJobGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ShortcutJobGet(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ShortcutJobGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get private registries in your account
     * @param {ToolkitApiV1ShortcutPrivateRegistryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ShortcutPrivateRegistryGet(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ShortcutPrivateRegistryGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create private registry in your account
     * @param {ToolkitApiV1ShortcutPrivateRegistryPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ShortcutPrivateRegistryPost(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ShortcutPrivateRegistryPost(requestParameters.human, requestParameters.privateregistryPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get jobs in your account which are replica jobs
     * @param {ToolkitApiV1ShortcutReplicasJobsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ShortcutReplicasJobsGet(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ShortcutReplicasJobsGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get services in your account
     * @param {ToolkitApiV1ShortcutServiceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ShortcutServiceGet(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ShortcutServiceGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create service in your account
     * @param {ToolkitApiV1ShortcutServicePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ShortcutServicePost(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ShortcutServicePost(requestParameters.human, requestParameters.servicePost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get teams in your organization
     * @param {ToolkitApiV1ShortcutTeamGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ShortcutTeamGet(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ShortcutTeamGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create team in your organization
     * @param {ToolkitApiV1ShortcutTeamPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ShortcutTeamPost(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ShortcutTeamPost(requestParameters.human, requestParameters.team, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get users in your organization
     * @param {ToolkitApiV1ShortcutUserGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ShortcutUserGet(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ShortcutUserGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create user in your organization
     * @param {ToolkitApiV1ShortcutUserPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1ShortcutUserPost(requestParameters = {}, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1ShortcutUserPost(requestParameters.human, requestParameters.userPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get swagger.json
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1SwaggerGetJson(options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1SwaggerGetJson(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the team identified by id
     * @param {ToolkitApiV1TeamGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1TeamGetById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1TeamGetById(requestParameters.teamId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Check access to the team
     * @param {ToolkitApiV1TeamHeadByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1TeamHeadById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1TeamHeadById(requestParameters.teamId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a member in the team
     * @param {ToolkitApiV1TeamMemberDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1TeamMemberDelete(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1TeamMemberDelete(requestParameters.teamId, requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get members in the team
     * @param {ToolkitApiV1TeamMemberGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1TeamMemberGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1TeamMemberGet(requestParameters.teamId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post a member in the team
     * @param {ToolkitApiV1TeamMemberPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1TeamMemberPost(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1TeamMemberPost(requestParameters.teamId, requestParameters.memberId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a policy in the team
     * @param {ToolkitApiV1TeamPolicyDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1TeamPolicyDelete(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1TeamPolicyDelete(requestParameters.teamId, requestParameters.policyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get policies in the team
     * @param {ToolkitApiV1TeamPolicyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1TeamPolicyGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1TeamPolicyGet(requestParameters.teamId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.includeInactive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post a policy in the team
     * @param {ToolkitApiV1TeamPolicyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1TeamPolicyPost(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1TeamPolicyPost(requestParameters.teamId, requestParameters.human, requestParameters.policyPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update team
     * @param {ToolkitApiV1TeamPutByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1TeamPutById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1TeamPutById(requestParameters.teamId, requestParameters.human, requestParameters.teamPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get roles in the team
     * @param {ToolkitApiV1TeamRoleGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1TeamRoleGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1TeamRoleGet(requestParameters.teamId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post a role in the team
     * @param {ToolkitApiV1TeamRolePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1TeamRolePost(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1TeamRolePost(requestParameters.teamId, requestParameters.human, requestParameters.rolePost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Check permission (action & resource) for a given user
     * @param {ToolkitApiV1UserAllowedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1UserAllowedGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1UserAllowedGet(requestParameters.action, requestParameters.resource, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get apps for the user
     * @param {ToolkitApiV1UserAppGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1UserAppGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1UserAppGet(requestParameters.userId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the user identified by id
     * @param {ToolkitApiV1UserGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1UserGetById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1UserGetById(requestParameters.userId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Check access to the user
     * @param {ToolkitApiV1UserHeadByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1UserHeadById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1UserHeadById(requestParameters.userId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get jobs created by the user
     * @param {ToolkitApiV1UserJobGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1UserJobGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1UserJobGet(requestParameters.userId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get job occupation statistics for a user
     * @param {ToolkitApiV1UserJobOccupancyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1UserJobOccupancyGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1UserJobOccupancyGet(requestParameters.userId, requestParameters.type, requestParameters.from, requestParameters.to, requestParameters.noNull, requestParameters.limit, requestParameters.offset, requestParameters.order, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get runs of jobs created by the user
     * @param {ToolkitApiV1UserJobRunGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1UserJobRunGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1UserJobRunGet(requestParameters.userId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a policy in the user
     * @param {ToolkitApiV1UserPolicyDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1UserPolicyDelete(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1UserPolicyDelete(requestParameters.userId, requestParameters.policyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get policies in the user
     * @param {ToolkitApiV1UserPolicyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1UserPolicyGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1UserPolicyGet(requestParameters.userId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, requestParameters.includeInactive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Post a policy in the user
     * @param {ToolkitApiV1UserPolicyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1UserPolicyPost(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1UserPolicyPost(requestParameters.userId, requestParameters.human, requestParameters.policyPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update user
     * @param {ToolkitApiV1UserPutByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1UserPutById(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1UserPutById(requestParameters.userId, requestParameters.human, requestParameters.userPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all jobs created by the user which are replica jobs
     * @param {ToolkitApiV1UserReplicaJobsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1UserReplicaJobsGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1UserReplicaJobsGet(requestParameters.userId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get terms of the organization of the user
     * @param {ToolkitApiV1UserTermsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1UserTermsGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1UserTermsGet(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Set terms as readed for the user
     * @param {ToolkitApiV1UserTermsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1UserTermsPut(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1UserTermsPut(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the users and roles that have permission to perform the given action(s) on the given resource(s)
     * @param {ToolkitApiV1WhoIsAllowedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolkitApi
     */
    v1WhoIsAllowedGet(requestParameters, options) {
        return (0, exports.ToolkitApiFp)(this.configuration).v1WhoIsAllowedGet(requestParameters.resource, requestParameters.action, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ToolkitApi = ToolkitApi;
